import StudyLogoPDF from "./StudyLogoPDF";
import { Document, Font, Image, Page, Text, View } from "@react-pdf/renderer";
import * as React from "react";
import fontRobotoRegular from "../../assets/fonts/Roboto/Roboto-Regular.ttf";
import fontRobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import fontRobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";
import fontRobotoMedium from "../../assets/fonts/Roboto/Roboto-Medium.ttf";
import fontRobotoItalic from "../../assets/fonts/Roboto/Roboto-MediumItalic.ttf";
import { API_BASE_URL } from "../../config";
import { useState, useEffect } from "react";
import axios from "axios";
import useIsMountedRef from "../mountedRef";
import moment from "moment/moment";
import { pdfStyles as styles } from "./pdfStyles";
import GenerateDMTGPdfFile from "./generate.DMTG.PDF";

Font.register({ family: "RobotoRegular", src: fontRobotoRegular });
Font.register({ family: "RobotoLight", src: fontRobotoLight });
Font.register({ family: "RobotoMedium", src: fontRobotoMedium });
Font.register({ family: "RobotoBold", src: fontRobotoBold });
Font.register({ family: "RobotoItalic", src: fontRobotoItalic });
Font.registerHyphenationCallback((word) => [word]);

let newDate = new Date();
let month = newDate.getMonth() + 1;
let year = newDate.getFullYear();
let day = newDate.getDate();

if (month < 10) {
  month = "0" + month;
}

if (day < 10) {
  day = "0" + day;
}
const currentDate = `${day}/${month}/${year}`;

const GeneratePdfFile = ({ simulateurObject, TblArticleValue }) => {
  
  let remarque = localStorage.getItem("remarque");

  let currUser = JSON.parse(localStorage.getItem("user"));

  let requestSimu = JSON.parse(localStorage.getItem("requestSimu"));

  let nameSimu = localStorage.getItem("nameSimu");

  let result;
  if (simulateurObject["results"]["custom"].length > 0) {
    result = simulateurObject["results"]["custom"];
  } else {
    result = simulateurObject["results"]["output"];
  }
  
  const emolFormValue = simulateurObject.results.output.find(
    (item) => item.key === "Emol_Form"
  )?.value;

  let servitudes = [34, 35];

  let valeurSPF = [76, 81, 82];

  let simuPret = [84, 85, 86, 87, 88, 90, 91, 92, 93, 94, 97];
  
  let simuCautionnement = [89, 90, 91, 96, 97];

  let simuDonation = [48, 49];

  let simuLicitation = [22, 23, 24, 25];

  let simuDependances = [1, 2, 3, 4, 5, 6, 7, 8, 9, 12, 13, 14, 15, 16, 17, 115, 117];

  let simuVentes = [1, 2, 3, 4, 115, 117];

  let dmtgPdfRequest = null;
  let dmtgPdfResults = [];

  const isMountedRef = useIsMountedRef();
  const [DepsArticles, setDepsArticles] = useState(null);
  const [setLoading] = useState(true);
  const tauxTvaObject = result.find(item => item.key === 'taux_tva');
  const tauxTva = tauxTvaObject ? parseFloat(tauxTvaObject.value) / 100 : null;
  
  // Récupération du taux d'accessoires personnalisé
  let tauxAccessoires = requestSimu.inputs["taux_accessoires"] ? parseFloat(requestSimu.inputs["taux_accessoires"]) : 20;
  
  var montantTTC_honoraires = 0;
  var nombreExemplaires;
  if (requestSimu.inputs["convention_honoraires"] === 1) {
     montantTTC_honoraires = (parseFloat(requestSimu.pdfInputs["montant_convention_honoraires"]) || 0) * (1 + tauxTva);
     nombreExemplaires = parseInt(requestSimu.pdfInputs["nombre_convention_honoraires"]) || 1;
  }


  let SimulateurID = requestSimu.simulateurid;

  useEffect(() => {
    const fetchData = async () => {
      try {
        var articlesRequest = {
          method: "get",
          url: `${API_BASE_URL}/articles`,
          headers: {
            "Content-Type": "application/json",
            Authorization: JSON.parse(localStorage.getItem("user"))?.jwt,
          },
        };

        const response = await axios(articlesRequest);

        const depsArticle = [];

        if (simulateurObject?.data?.dependances?.length > 0) {
          for (let i = 0; i < simulateurObject.data.dependances.length; i++) {
            const foundArticle = response.data.find(
              (article) => article.SimulateurID === simulateurObject.data.dependances[i].simulateurid
            );
  
            if (foundArticle) {
              depsArticle.push(foundArticle.TblArticle);
            } else {
              console.warn(
                `Aucun article trouvé : ${simulateurObject.data.dependances[i].simulateurid}`
              );
              depsArticle.push(null);
            }
          }
          setDepsArticles(depsArticle);
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des articles :", error);
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMountedRef.current = false;
    };
  }, [SimulateurID, isMountedRef]);

  const hasCsiVolontaire =
    requestSimu?.simulateurid === 76 && parseInt(requestSimu?.inputs?.csi_volontaire || 0) > 0;

  if (requestSimu?.DMTG?.length > 0) {
    dmtgPdfRequest = { data: requestSimu.DMTG };
    try {
      dmtgPdfResults = JSON.parse(localStorage.getItem("arrayContent")) || [];
    } catch (e) {
      dmtgPdfResults = [];
    }
  }
  let persoEmol = JSON.parse(localStorage.getItem("persoEmol"));

  let simu84Index = null;
  let simu85Index = null;
  let simu89Index = null;
  let simu90Index = null;
  let simu92Index = null;
  let simu96Index = null;
  let simu97Index = null;
  let simu114Index = null;

  if (simulateurObject?.data?.dependances?.length > 0) {
    for (let i = 0; i < simulateurObject.data.dependances.length; i++) {
      if (simulateurObject.data.dependances[i].simulateurid === 84) simu84Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 85) simu85Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 89) simu89Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 90) simu90Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 92) simu92Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 96) simu96Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 97) simu97Index = i;
      if (simulateurObject.data.dependances[i].simulateurid === 114) simu114Index = i;
    }
    if (DepsArticles == null) {
      return null;
    }
  }
  // Fonction pour récupérer le taux d'accessoires correct pour un simulateur donné
  const getTauxAccessoiresForSimulateur = (simulateurId) => {
    if (simulateurId === requestSimu.simulateurid) {
      // Taux du simulateur principal
      return requestSimu.inputs["taux_accessoires"] ? parseFloat(requestSimu.inputs["taux_accessoires"]) : 20;
    }
    // Taux des dépendances
    const dependance = simulateurObject?.data?.dependances?.find(dep => dep.simulateurid === simulateurId);
    return dependance?.inputs?.taux_accessoires ? parseFloat(dependance.inputs.taux_accessoires) : 20;
  };

  function checkAndTransformNullToZero(field) {
    if (field !== null && field !== undefined) return field;
    else return 0;
  }

  const RenderChart = () => (
    <Image
      source={{ uri: localStorage.getItem("chart") }}
      style={styles.chartImage}
    />
  );
  const renderDroitDePartage = () => {
    if (
      requestSimu.simulateurid === 79 ||
      requestSimu.simulateurid === 59 ||
      requestSimu.simulateurid === 22 ||
      requestSimu.simulateurid === 61 ||
      requestSimu.simulateurid === 23 ||
      (requestSimu.simulateurid === 60 && simulateurObject?.data?.inputs?.droit_partage_reduit === 0)
    ) {
      return (
        <View style={styles.detailsSubjectField}>
          <Text style={styles.detailsSubjectText}>
            Dont droit de partage (2,50%)
          </Text>
        </View>
      );
    } else if (
      requestSimu.simulateurid === 58 ||
      (requestSimu.simulateurid === 60 && simulateurObject?.data?.inputs?.droit_partage_reduit === 1)
    ) {
      return (
        <View style={styles.detailsSubjectField}>
          <Text style={styles.detailsSubjectText}>
            Dont droit de partage (1,10%)
          </Text>
        </View>
      );
    }
  };

  const renderDMTO = (result, primoPresent, primo) => {
    const tauxDmto = (primoPresent && !primo ? result.find((item) => item.key === "taux_dmto_normal")?.value : undefined) ??
        result.find((item) => item.key === "taux_dmto")?.value;
    return (
      <View style={styles.detailsSubjectField}>
        <Text style={styles.detailsSubjectText}>
          Dont DMTO ({tauxDmto})
        </Text>
      </View>
    );
  };

  const formatMontant = (value) => {
    return parseInt(value).toLocaleString("en-EN").replace(/,/g, " ") + " €";
  };

  const parseCurrencyValue = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const normalizedValue = value
      .toString()
      .replace(/\s/g, "")
      .replace("€", "")
      .replace(",", ".");
    const numericValue = parseFloat(normalizedValue);
    return Number.isNaN(numericValue) ? 0 : numericValue;
  };

  const isZeroEuroValue = (value) => {
    if (value === "" || value === null || value === undefined) return false;
    const numericValue = parseFloat(value.toString().replace(/\s/g, "").replace(",", "."));
    return !Number.isNaN(numericValue) && numericValue === 0;
  };

  const getResultValue = (key) => result.find((item) => item.key === key)?.value ?? "";

  // csi publication servitudes
  const getCsiPublicationValues = (result) => {
    const csiPublicationValues = [];
    const csiPublicationOccurrence = result.find((item) => item.key.startsWith("csi_publication_"));

    if (csiPublicationOccurrence) {
      for (let i = 1; i <= 10; i++) {
        const key = `csi_publication_${i}`;
        const object = result.find((item) => item.key === key);

        if (object) {
          csiPublicationValues.push(object.value);
        }
      }
    } else {
      const csiPublication = result.find((item) => item.key === "csi_publication");
      if (csiPublication) {
        csiPublicationValues.push(csiPublication.value);
      }
    }

    return csiPublicationValues;
  };

  const csiPublicationValues = getCsiPublicationValues(result);

  const getCsiPublicationSpfRows = () => {
    if (requestSimu?.simulateurid !== 76 || !requestSimu?.dependances?.length) return [];

    const rows = requestSimu.dependances
      .map((dependance, index) => {
        const epoux1 = parseCurrencyValue(dependance?.epoux1);
        const epoux2 = parseCurrencyValue(dependance?.epoux2);
        const valeurSpf = parseCurrencyValue(dependance?.valeur_spf) || epoux1 + epoux2;
        const isCsiVolontaire = epoux1 === epoux2 && epoux1 > 0;
        const base = isCsiVolontaire ? valeurSpf : Math.abs(epoux1 - epoux2) / 2;

        return base > 0 ? {
          index,
          base,
          isCsiVolontaire,
        } : null;
      })
      .filter(Boolean);

    const baseCsiPublication = parseCurrencyValue(getResultValue("base_csi_publication")) ||
      rows.filter((row) => !row.isCsiVolontaire).reduce((total, row) => total + row.base, 0);
    const baseCsiVolontaire = parseCurrencyValue(getResultValue("base_csi_volontaire")) ||
      rows.filter((row) => row.isCsiVolontaire).reduce((total, row) => total + row.base, 0);
    const csiPublication = parseCurrencyValue(getResultValue("csi_publication"));
    const csiVolontaire = parseCurrencyValue(getResultValue("csi_volontaire"));

    return rows
      .map((row) => ({
        ...row,
        totalAmount: row.isCsiVolontaire ? csiVolontaire : csiPublication,
        totalBase: row.isCsiVolontaire ? baseCsiVolontaire : baseCsiPublication,
      }))
      .filter((row) => row.totalAmount > 0 && row.totalBase > 0)
      .map((row) => ({
        ...row,
        amount: `${(row.totalAmount * row.base / row.totalBase).toFixed(2).toLocaleString("en-EN").replace(/,/g, " ")} €`,
      }));
  };

  const csiPublicationSpfRows = getCsiPublicationSpfRows();

  // emol acte servitudes
  const getEmolActeValues = (result) => {
    const emolActeValues = [];
    const emolActeOccurrence = result.find((item) => item.key.startsWith("emoluments_actes_"));

    if (emolActeOccurrence) {
      for (let i = 1; i <= 10; i++) {
        const key = `emoluments_actes_${i}`;
        const object = result.find((item) => item.key === key);

        if (object) {
          emolActeValues.push(object.value);
        }
      }
    } else {
      const emolActe = result.find((item) => item.key === "emoluments_actes");
      if (emolActe) {
        emolActeValues.push(emolActe.value);
      }
    }

    return emolActeValues;
  };

  const emolActeValues = getEmolActeValues(result);

  // dmto servitudes
  const getDmtoValues = (result) => {
    const dmtoValues = [];
    const dmtoOccurrence = result.find((item) => item.key.startsWith("droit_mutation_"));

    if (dmtoOccurrence) {
      for (let i = 1; i <= 10; i++) {
        const key = `droit_mutation_${i}`;
        const object = result.find((item) => item.key === key);

        if (object) {
          dmtoValues.push(object.value);
        }
      }
    } else {
      const dmto = result.find((item) => item.key === "droit_mutation");
      if (dmto) {
        dmtoValues.push(dmto.value);
      }
    }

    return dmtoValues;
  };

  const dmtoValues = getDmtoValues(result);

  // base trésor servitudes
  const getBaseTresorValues = (result) => {
    const baseTresorValues = [];
    const baseTresorOccurrence = result.find((item) => item.key.startsWith("base_tresor_"));

    if (baseTresorOccurrence) {
      for (let i = 1; i <= 10; i++) {
        const key = `base_tresor_${i}`;
        const object = result.find((item) => item.key === key);

        if (object) {
          baseTresorValues.push(object.value);
        }
      }
    } else {
      const baseTresor = result.find((item) => item.key === "base_tresor");
      if (baseTresor) {
        baseTresorValues.push(baseTresor.value);
      }
    }

    return baseTresorValues;
  };

  const baseTresorValues = getBaseTresorValues(result);

  // base CSI SPF
  const getBaseCsiValues = (result) => {
    const baseCsiValues = [];
    const baseCsiOccurrence = result.find((item) => item.key.startsWith("base_csi_publication_"));

    if (baseCsiOccurrence) {
      for (let i = 1; i <= 10; i++) {
        const key = `base_csi_publication_${i}`;
        const object = result.find((item) => item.key === key);

        if (object) {
          baseCsiValues.push(object.value);
        }
      }
    } else {
      const baseCsi = result.find((item) => item.key === "base_csi_publication");
      if (baseCsi) {
        baseCsiValues.push(baseCsi.value);
      }
    }

    return baseCsiValues;
  };

  const baseCsiValues = getBaseCsiValues(result);

  // base Emol servitudes
  const getBaseEmolValues = (result) => {
    const baseEmolValues = [];
    const baseEmolOccurrence = result.find((item) => item.key.startsWith("base_emol_"));

    if (baseEmolOccurrence) {
      for (let i = 1; i <= 10; i++) {
        const key = `base_emol_${i}`;
        const object = result.find((item) => item.key === key);

        if (object) {
          baseEmolValues.push(object.value);
        }
      }
    } else {
      const baseEmol = result.find((item) => item.key === "base_emol");
      if (baseEmol) {
        baseEmolValues.push(baseEmol.value);
      }
    }

    return baseEmolValues;
  };

  const baseEmolValues = getBaseEmolValues(result);

  const tresorTotalValue = result.find((object) => object.key === "Tresor_total")?.value;
  const droitEtatValue = result.find(
    (object) =>
      object.key === "droit_etat" || object.key === "droit_etat_acte_separe" || object.key === "droit_etat_promesse"
  )?.value;

  const emol1Value = result.find((object) => object.key === "emoluments_actes_1")?.value;
  const emol2Value = result.find((object) => object.key === "emoluments_actes_2")?.value;

  // on cherche les droits états
  const hasDroitEtat = simulateurObject?.results?.output.some(
    (item) => item.key === "droit_etat" && item.value !== "0 €"
  );
  const hasDroitEtatPromesse = simulateurObject?.results?.output.some(
    (item) => item.key === "droit_etat_promesse" && item.value !== "0 €"
  );
  const hasDroitEtatActeSepareDependances = simulateurObject?.data?.dependances?.some(
    (dependance) =>
      dependance.output?.hasOwnProperty("droit_etat_acte_separe") && dependance.output.droit_etat_acte_separe !== "0 €"
  );

  // On vérifie s'il s'agit d'une dépendance
  function isDependanceValid(simuIndex) {
    const dependance = simulateurObject?.data?.dependances?.[simuIndex] ?? null;
    return dependance !== null && dependance !== undefined;
  }

  // On récupère et on formatte les variables
  function formatOutputBaseEmolValue(simuIndex) {
    const baseEmolValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.base_emol ?? 0;
    const formattedValue = parseInt(baseEmolValue?.toFixed(2)).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }
  const formattedBaseEmolValue84 = formatOutputBaseEmolValue(simu84Index);
  const formattedBaseEmolValue85 = formatOutputBaseEmolValue(simu85Index);
  const formattedBaseEmolValue89 = formatOutputBaseEmolValue(simu89Index);
  const formattedBaseEmolValue90 = formatOutputBaseEmolValue(simu90Index);
  const formattedBaseEmolValue92 = formatOutputBaseEmolValue(simu92Index);
  const formattedBaseEmolValue96 = formatOutputBaseEmolValue(simu96Index);
  const formattedBaseEmolValue97 = formatOutputBaseEmolValue(simu97Index);
  const formattedBaseEmolValue114 = formatOutputBaseEmolValue(simu114Index);

  function formatOutputEmolValue(simuIndex) {
    const emolValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.emoluments_actes_total ?? 0;
    const formattedValue = emolValue?.toFixed(2).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }
  const formattedEmolValue84 = formatOutputEmolValue(simu84Index);
  const formattedEmolValue85 = formatOutputEmolValue(simu85Index);
  const formattedEmolValue89 = formatOutputEmolValue(simu89Index);
  const formattedEmolValue90 = formatOutputEmolValue(simu90Index);
  const formattedEmolValue92 = formatOutputEmolValue(simu92Index);
  const formattedEmolValue96 = formatOutputEmolValue(simu96Index);
  const formattedEmolValue97 = formatOutputEmolValue(simu97Index);
  const formattedEmolValue114 = formatOutputEmolValue(simu114Index);

  function formatOutputEmolFormValue(simuIndex) {
    const emolFormValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.emoluments_formalites_total;
    const formattedValue = emolFormValue?.toFixed(2).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }
  const formattedEmolFormValue84 = formatOutputEmolFormValue(simu84Index);
  const formattedEmolFormValue85 = formatOutputEmolFormValue(simu85Index);
  const formattedEmolFormValue89 = formatOutputEmolFormValue(simu89Index);
  const formattedEmolFormValue90 = formatOutputEmolFormValue(simu90Index);
  const formattedEmolFormValue92 = formatOutputEmolFormValue(simu92Index);
  const formattedEmolFormValue96 = formatOutputEmolFormValue(simu96Index);
  const formattedEmolFormValue97 = formatOutputEmolFormValue(simu97Index);
  const formattedEmolFormValue114 = formatOutputEmolFormValue(simu114Index);

  function formatOutputTresorTotal(simuIndex) {
    const tresorTotalValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.Tresor_total ?? 0;
    return `${tresorTotalValue?.toFixed(2).toLocaleString("en-EN").replace(/,/g, " ")} €`;
  }

  const formattedTresorTotal84 = formatOutputTresorTotal(simu84Index);
  const formattedTresorTotal85 = formatOutputTresorTotal(simu85Index);
  const formattedTresorTotal89 = formatOutputTresorTotal(simu89Index);
  const formattedTresorTotal90 = formatOutputTresorTotal(simu90Index);
  const formattedTresorTotal92 = formatOutputTresorTotal(simu92Index);
  const formattedTresorTotal96 = formatOutputTresorTotal(simu96Index);
  const formattedTresorTotal97 = formatOutputTresorTotal(simu97Index);
  const formattedTresorTotal114 = formatOutputTresorTotal(simu114Index);

  function formatOutputBaseTpf(simuIndex) {
    const baseTpfValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.base_tpf ?? 0;
    const formattedValue = parseInt(baseTpfValue?.toFixed(2)).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }

  const formattedBaseTpf84 = formatOutputBaseTpf(simu84Index);
  const formattedBaseTpf85 = formatOutputBaseTpf(simu85Index);
  const formattedBaseTpf92 = formatOutputBaseTpf(simu92Index);

  function formatOutputBaseTresor(simuIndex) {
    const baseTresorValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.base_tresor ?? 0;
    const formattedValue = parseInt(baseTresorValue?.toFixed(2)).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }

  const formattedBaseTresor90 = formatOutputBaseTresor(simu90Index);
  const formattedBaseTresor97 = formatOutputBaseTresor(simu97Index);

  function formatOutputTpfValue(simuIndex) {
    const tpfValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.tpf ?? 0;
    return `${tpfValue?.toFixed(2).toLocaleString("en-EN").replace(/,/g, " ")} €`;
  }

  const formattedTpfValue84 = formatOutputTpfValue(simu84Index);
  const formattedTpfValue85 = formatOutputTpfValue(simu85Index);
  const formattedTpfValue92 = formatOutputTpfValue(simu92Index);
  const formattedTpfValue90 = formatOutputTpfValue(simu90Index);
  const formattedTpfValue97 = formatOutputTpfValue(simu97Index);

  function formatOutputBaseCsiInscription(simuIndex) {
    const baseCsiInscriptionValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.base_csi_inscription ?? 0;
    const formattedValue = parseInt(baseCsiInscriptionValue?.toFixed(2)).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }

  const formattedBaseCsiInscription84 = formatOutputBaseCsiInscription(simu84Index);
  const formattedBaseCsiInscription85 = formatOutputBaseCsiInscription(simu85Index);
  const formattedBaseCsiInscription92 = formatOutputBaseCsiInscription(simu92Index);

  function formatOutputCsiInscriptionValue(simuIndex) {
    const csiInscriptionValueValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.csi_inscription ?? 0;
    return `${csiInscriptionValueValue?.toFixed(2).toLocaleString("en-EN").replace(/,/g, " ")} €`;
  }

  const formattedCsiInscriptionValue84 = formatOutputCsiInscriptionValue(simu84Index);
  const formattedCsiInscriptionValue85 = formatOutputCsiInscriptionValue(simu85Index);
  const formattedCsiInscriptionValue92 = formatOutputCsiInscriptionValue(simu92Index);
  const formattedCsiInscriptionValue90 = formatOutputCsiInscriptionValue(simu90Index);
  const formattedCsiInscriptionValue97 = formatOutputCsiInscriptionValue(simu97Index);

  function formatOutputDroitEtat(simuIndex) {
    const droitEtatValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.droit_etat_acte_separe ?? 0;
    return `${droitEtatValue} €`;
  }

  const formattedDroitEtat84 = formatOutputDroitEtat(simu84Index);
  const formattedDroitEtat85 = formatOutputDroitEtat(simu85Index);
  const formattedDroitEtat89 = formatOutputDroitEtat(simu89Index);
  const formattedDroitEtat92 = formatOutputDroitEtat(simu92Index);
  const formattedDroitEtat90 = formatOutputDroitEtat(simu90Index);
  const formattedDroitEtat96 = formatOutputDroitEtat(simu96Index);
  const formattedDroitEtat97 = formatOutputDroitEtat(simu97Index);
  const formattedDroitEtat114 = formatOutputDroitEtat(simu114Index);

  function formatOutputDeboursValue(simuIndex) {
    const DeboursValue = simulateurObject?.data?.dependances?.[simuIndex]?.output?.Debours_total;
    const formattedValue = parseInt(DeboursValue?.toFixed(2)).toLocaleString("en-EN").replace(/,/g, " ");
    return `${formattedValue} €`;
  }
  const formattedDeboursValue84 = formatOutputDeboursValue(simu84Index);
  const formattedDeboursValue85 = formatOutputDeboursValue(simu85Index);
  const formattedDeboursValue89 = formatOutputDeboursValue(simu89Index);
  const formattedDeboursValue90 = formatOutputDeboursValue(simu90Index);
  const formattedDeboursValue92 = formatOutputDeboursValue(simu92Index);
  const formattedDeboursValue96 = formatOutputDeboursValue(simu96Index);
  const formattedDeboursValue97 = formatOutputDeboursValue(simu97Index);
  const formattedDeboursValue114 = formatOutputDeboursValue(simu114Index);

  return (
    // <PDFViewer style={{width: "98vw", height: "98vh"}}>
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerRight}>
          <StudyLogoPDF user={currUser} />
          <Text style={styles.headerName}>{currUser.societe}</Text>
          <Text style={styles.headerAdress}>{currUser.societe_address}</Text>

          <Text style={styles.headerAdress}>{currUser.societe_zip + " " + currUser.societe_town}</Text>

          <Text style={styles.headerDate}>Dossier suivi par : {currUser.firstname + " " + currUser.lastname}</Text>

          <View style={styles.headerDate}>
            <Text>Le : {currentDate}</Text>
          </View>
        </View>
        <View style={styles.containerTitleSimu}>
          <Text style={styles.titleSimu}>
            {requestSimu?.simulateurid === 22
              ? "Licitation maintenant l'indivision, régime de FAVEUR - droit de partage à 2,50%. Indivision issue d'une succession, entre époux mariés sous le régime de la séparation de biens, entre partenaires de PACS"
              : requestSimu?.simulateurid === 23
              ? "Licitation faisant cesser l'indivision, régime de FAVEUR - droit de partage à 2,50%. Indivision issue d'une succession, entre époux mariés sous le régime de la séparation de biens, entre partenaires de PACS"
              : requestSimu?.simulateurid === 52
              ? "Déclaration de succession (Émoluments de DS et calcul de DMTG 1er et 2e décès)"
              : requestSimu?.simulateurid === 55
              ? "DMTG - Succession 1 à 9 personnes (1er et 2e décès)"
              : requestSimu?.simulateurid === 84
              ? "Prêts aux particuliers garantis par une HLPD (Hypothèque légale de prêteur de denier) et/ou une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)"
              : requestSimu?.simulateurid === 85
              ? "Prêts aux particuliers à l'accession à la propriété (PAS, PSI, PTZ+) ou prêts à la construction garantis par une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)"
              : requestSimu?.simulateurid === 92
              ? "Prêts aux professionnels garantis par une HLPD (Hypothèque légale de prêteur de denier) et/ou une hypothèque conventionnelle (HC) et/ou un cautionnement (garanti ou non par une HC)"
              : nameSimu}
          </Text>
        </View>
        <View style={styles.remarque}>
          <Text style={styles.remarqueText}>Remarques : {remarque}</Text>
        </View>

        <View style={styles.ttc}>
          <View style={styles.ttcInternCtn}>
            <Text style={styles.ttcLeft}>Estimation du montant total de vos frais :</Text>

            <Text style={styles.ttcRight}>
              {(() => {
                for (let i = 0; i < result.length; i++) {
                  if (result[i].key === "Provision_total") {
                    const numericValue = (parseFloat(result[i].value) || 0);
                    const roundedValue = Math.ceil(numericValue);
                    const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                    return (formattedValue + " €").toString();
                  }
                }
                return "";
              })()}
            </Text>
          </View>
        </View>
        
        {/* {console.log("Contenu de requestSimu:", requestSimu)} */}
        {requestSimu.inputs.type_demembrement === 1 && persoEmol === null ? (
          <View style={styles.ttcDetail}>
            <View style={[styles.ttcInternCtn, styles.ttcInternCtnTight]}>
              <Text style={styles.ttcLeft}>Dont montant à la charge de l'usufruitier :</Text>

              <Text style={styles.ttcRight}>
                {(() => {
                  for (let i = 0; i < result.length; i++) {
                    if (result[i].key === "Provision_us") {
                      const numericValue = (parseFloat(result[i].value) || 0);
                      const roundedValue = Math.ceil(numericValue);
                      const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                      return (formattedValue + " €").toString();
                    }
                  }
                  return "";
                })()}
              </Text>
            </View>
            <View style={[styles.ttcInternCtn, styles.ttcInternCtnTight]}>
              <Text style={styles.ttcLeft}>Dont montant à la charge du nu-propriétaire :</Text>

              <Text style={styles.ttcRight}>
                {(() => {
                  for (let i = 0; i < result.length; i++) {
                    if (result[i].key === "Provision_np") {
                      const numericValue = (parseFloat(result[i].value) || 0);
                      const roundedValue = Math.ceil(numericValue);
                      const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                      return (formattedValue + " €").toString();
                    }
                  }
                  return "";
                })()}
              </Text>
            </View>
          </View>
        ) : null}

        <View style={styles.bodyCtnRow}>
          <View style={styles.blockLeft}>
            <View style={styles.blockEmoluments}>
              <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.emoluments}>Total Émoluments</Text>
                <View style={styles.ctnResultatsNbTop}>
                  <Text style={styles.resultatsNb}>
                    {(() => {
                      for (let i = 0; i < result.length; i++) {
                        if (result[i].key === "Emol_total") {
                          const numericValue = parseFloat(result[i].value);
                          const roundedValue = Math.ceil(numericValue);
                          const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                          return (formattedValue + " € HT").toString();
                        }
                      }
                      return "";
                    })()}
                  </Text>
                </View>
              </View>
             <View style={styles.ctnResultatsTxt2}>
              {emolFormValue === "-1 €" ? (
                // --- CAS 1 : ÉCRÊTEMENT ---
                <View style={styles.superEmol}>
                  <Text style={styles.ctnEmol}>Émoluments (écrêtés)</Text>
                  <View style={styles.ctnResultatsNb2}>
                    <Text style={styles.resultatsNb2}>
                      {(() => {
                        const emolTotal = result.find(item => item.key === "Emol_total");
                        if (emolTotal) {
                          const roundedValue = Math.ceil(parseFloat(emolTotal.value));
                          return roundedValue.toLocaleString("en-EN").replace(/,/g, " ") + " € HT";
                        }
                        return "0 € HT";
                      })()}
                    </Text>
                  </View>
                </View>
              ) : (
                // --- CAS 2 : NORMAL  ---
                <>
                  {requestSimu.hasOwnProperty("dependances") &&
                  requestSimu.simulateurid !== 34 &&
                  requestSimu.simulateurid !== 35 &&
                  requestSimu.simulateurid !== 76 &&
                  requestSimu.simulateurid !== 81 &&
                  requestSimu.simulateurid !== 82 ? (
                    <View style={styles.superEmol}>
                      <Text style={styles.ctnEmol}>
                        {simuVentes.includes(requestSimu.simulateurid) ? "Vente" : "Émoluments d'acte"}
                      </Text>
                      <View style={styles.ctnResultatsNb2}>
                        <Text style={styles.resultatsNb2}>
                          {(() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "emoluments_actes") {
                                const numericValue = parseFloat(result[i].value);
                                const roundedValue = Math.ceil(numericValue);
                                const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                                return (formattedValue + " € HT").toString();
                              }
                            }
                            return "";
                          })()}
                        </Text>
                      </View>
                    </View>
                  ) : requestSimu.simulateurid === 32 || requestSimu.simulateurid === 83 ? (
                    <View style={styles.superEmol}>
                      <Text style={styles.ctnEmol}>Émoluments total</Text>
                      <View style={styles.ctnResultatsNb2}>
                        <Text style={styles.resultatsNb2}>
                          {(() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "Emol_total") {
                                const formattedValue = parseInt(result[i].value)
                                  .toLocaleString("en-EN")
                                  .replace(/,/g, " ");
                                return (formattedValue + " € HT").toString();
                              }
                            }
                            return "";
                          })()}
                        </Text>
                      </View>
                    </View>
                  ) : (
                    <View style={styles.superEmol}>
                      <Text style={styles.ctnEmol}>Émoluments d'acte</Text>
                      <View style={styles.ctnResultatsNb2}>
                        <Text style={styles.resultatsNb2}>
                          {(() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "emoluments_actes_total") {
                                const numericValue = parseFloat(result[i].value);
                                const roundedValue = Math.ceil(numericValue);
                                const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                                return (formattedValue + " € HT").toString();
                              }
                            }
                            return "";
                          })()}
                        </Text>
                      </View>
                    </View>
                  )}

                  {requestSimu.hasOwnProperty("dependances")
                    ? requestSimu?.dependances.map((dependance, index) => {
                        if (dependance.simulateurid === 84 || dependance.simulateurid === 85 || dependance.simulateurid === 92) {
                          return (
                            <View style={styles.superEmol} key={`dep-pret-${index}`}>
                              <Text style={styles.ctnEmol}>Prêt</Text>
                              <View style={styles.ctnResultatsNb2}>
                                <Text style={styles.resultatsNb2}>
                                  {(() => {
                                    const emolumentsActesTotal = parseFloat(requestSimu?.dependances[index]?.output?.emoluments_actes_total);
                                    const formattedValue = Math.ceil(emolumentsActesTotal).toLocaleString("en-EN").replace(/,/g, " ") + " € HT";
                                    return formattedValue;
                                  })()}
                                </Text>
                              </View>
                            </View>
                          );
                        } else if (dependance.simulateurid === 89 || dependance.simulateurid === 96 || dependance.simulateurid === 114) {
                          return (
                            <View style={styles.superEmol} key={`dep-caut-sans-${index}`}>
                              <Text style={styles.ctnEmol}>Cautionnement sans garantie</Text>
                              <View style={styles.ctnResultatsNb2}>
                                <Text style={styles.resultatsNb2}>
                                  {(() => {
                                    const emolumentsActesTotal = parseFloat(requestSimu?.dependances[index]?.output?.emoluments_actes_total);
                                    const formattedValue = Math.ceil(emolumentsActesTotal).toLocaleString("en-EN").replace(/,/g, " ") + " € HT";
                                    return formattedValue;
                                  })()}
                                </Text>
                              </View>
                            </View>
                          );
                        } else if (dependance.simulateurid === 90 || dependance.simulateurid === 97) {
                          return (
                            <View style={styles.superEmol} key={`dep-caut-avec-${index}`}>
                              <Text style={styles.ctnEmol}>Cautionnement avec garantie</Text>
                              <View style={styles.ctnResultatsNb2}>
                                <Text style={styles.resultatsNb2}>
                                  {(() => {
                                    const emolumentsActesTotal = parseFloat(requestSimu?.dependances[index]?.output?.emoluments_actes_total);
                                    const formattedValue = Math.ceil(emolumentsActesTotal).toLocaleString("en-EN").replace(/,/g, " ") + " € HT";
                                    return formattedValue;
                                  })()}
                                </Text>
                              </View>
                            </View>
                          );
                        } else {
                          return null;
                        }
                      })
                    : null}
                  
                  <View style={styles.superEmol}>
                    {requestSimu.simulateurid !== 32 && requestSimu.simulateurid !== 83 && (
                        <Text style={styles.ctnEmol}>Émoluments de formalités</Text>
                    )}
                    <View style={styles.ctnResultatsNb2}>
                      <Text style={styles.resultatsNb2}>
                        {(() => {
                          const emolFormTotal = result.find(item => item.key === "Emol_Form_Total");
                          if (emolFormTotal && emolFormTotal.value !== "écrêtés") {
                              const numericValue = parseFloat(emolFormTotal.value);
                              if (isNaN(numericValue)) return "0 € HT";
                              const roundedValue = Math.ceil(numericValue);
                              return roundedValue.toLocaleString("en-EN").replace(/,/g, " ") + " € HT";
                          }
                          return "";
                        })()}
                      </Text>
                    </View>
                  </View>
                </>
              )}

                {simulateurObject?.data?.inputs?.promesse === 1 || simulateurObject?.data?.inputs?.promesse === "1" ? (
                  <View style={styles.superEmol}>
                    <Text style={styles.ctnEmol}>Honoraires de la promesse</Text>
                    <View style={styles.ctnResultatsNb2}>
                      <Text style={styles.resultatsNb2}>
                        {parseInt(requestSimu.inputs["montant_promesse"]).toLocaleString("en-EN").replace(/,/g, " ") +
                          " € HT"}
                      </Text>
                    </View>
                  </View>
                ) : null}
              </View>
            </View>
              {/* Honoraire en cours de création */}
              {simulateurObject?.data?.inputs?.convention_honoraires === 1 || simulateurObject?.data?.inputs?.convention_honoraires === "1" ? (
                <View style={styles.blockHonoraire}>
                  <Text style={styles.honoraire}>Honoraires TTC</Text>
                  <View style={styles.ctnResultatsNb}>
                    <Text style={styles.resultatsNb}>
                      {(
                        (parseFloat(requestSimu.pdfInputs["montant_convention_honoraires"]) || 0) * (1 + tauxTva)).toLocaleString("en-EN").replace(/,/g, " ")} €
                    </Text>
                  </View>
                </View>
              ) : null}
          </View>

          <View style={styles.blockRight}>
            {simulateurObject?.data?.DMTG?.length > 0 ? (
              <View style={styles.blockFiscalite2}>
                <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.taxes}>Total Fiscalité</Text>
                  <View style={styles.ctnResultatsNbTop}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        let tva = 0;
                        let tresor = 0;
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "TVA_total") tva = parseFloat(result[i].value);
                          else if (result[i].key === "Tresor_total") {
                            tresor = parseFloat(result[i].value);
                          }
                        }
                        const totalValue = tva + tresor - (requestSimu.pdfInputs['montant_convention_honoraires'] * tauxTva);
                        const roundedTotal = Math.ceil(totalValue);
                        const formattedValue = roundedTotal.toLocaleString("en-EN").replace(/,/g, " ") + " €";
                        return formattedValue;
                      })()}
                    </Text>
                  </View>
                </View>

                <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.resultatsTxt}>Trésor</Text>
                  <View style={styles.ctnResultatsNb}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "Tresor_total") {
                            const numericValue = parseFloat(result[i].value);
                            const roundedValue = Math.ceil(numericValue);
                            const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </View>
                <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.resultatsTxt3}>Dont DMTG</Text>
                  <View style={styles.ctnResultatsNb3}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "DMTG") {
                            const formattedValue = Math.ceil(parseFloat(result[i].value)).toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </View>

                <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.resultatsTxt2}>TVA</Text>
                  <View style={styles.ctnResultatsNb3}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "TVA_total") {
                            const numericValue = parseFloat(result[i].value);
                            const roundedValue = Math.ceil(numericValue);
                            const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </View>
              </View>
            ) : (
              <View style={styles.blockFiscalite}>
                <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.taxes}>Total Fiscalité</Text>
                  <View style={styles.ctnResultatsNbTop}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        let tva = 0;
                        let tresor = 0;
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "TVA_total") {
                            tva = parseFloat(result[i].value);
                          } else if (result[i].key === "Tresor_total") {
                            tresor = parseFloat(result[i].value);
                          }
                        }
                        const totalValue = tva + tresor - (requestSimu.pdfInputs['montant_convention_honoraires'] * tauxTva);
                        const roundedTotal = Math.ceil(totalValue);
                        const formattedValue = roundedTotal.toLocaleString("en-EN").replace(/,/g, " ") + " €";
                        return formattedValue;
                      })()}
                    </Text>
                  </View>
                </View>

                <View style={styles.ctnResultatsTxt}>
                  <Text style={styles.resultatsTxt}>Trésor</Text>
                  <View style={styles.ctnResultatsNb}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "Tresor_total") {
                            const numericValue = parseFloat(result[i].value);
                            const roundedValue = Math.ceil(numericValue);
                            const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </View>

                <View style={styles.ctnResultatsTxt}>
                    <Text style={styles.resultatsTxt2}>TVA sur émoluments</Text>
                  <View style={styles.ctnResultatsNb}>
                    <Text style={styles.resultatsNb}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "TVA_total") {
                            const numericValue = parseFloat(result[i].value) - (requestSimu.pdfInputs['montant_convention_honoraires'] * tauxTva);
                            const roundedValue = Math.ceil(numericValue);
                            const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </View>
              </View>
            )}

            <View style={styles.blockDebours}>
              <Text style={styles.debours}>Débours</Text>
              <View style={styles.ctnResultatsNb}>
                <Text style={styles.resultatsNb}>
                  {(() => {
                    for (let i = 0; i < result.length; i++) {
                      if (result[i].key === "Debours_total") {
                        const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");
                        return (formattedValue + " €").toString();
                      }
                    }
                    return "";
                  })()}
                </Text>
              </View>
            </View>

               

          </View>
        </View>

        <View style={styles.ctnChart}>
          <RenderChart />
        </View>

        {/* MAP FOR INPUTS*/}

        <View style={styles.rappel}>
          <Text style={styles.bodyFooterMappedTitle}>Rappel de votre simulation :</Text>
          {requestSimu?.departementid !== 0 ? (
            <Text style={styles.bodyFooterMapped}>
              Département concerné :{" "}
              {requestSimu.departementid < 10 ? `0${requestSimu.departementid}` : requestSimu.departementid}
              {/*TODO Afficher le nom du département*/}
            </Text>
          ) : (
            <></>
          )}
          {Object.keys(requestSimu?.inputs).map((key) => {
            if (key === "taxe_ile_de_france") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Taxe IDF 0,6% : Oui</Text>;
              }
            } else if (key === "zrr") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>ZRR : Oui</Text>;
              }
            } else if (key === "acte_en_main") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Acte en main : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Acte en main : Non</Text>;
              }
            } else if (key === "convention_honoraires") {
              if (requestSimu.inputs[key] === 1) {
                return (
                <>
                  <Text style={styles.bodyFooterMapped}>
                    Convention d'honoraires : oui
                  </Text>
                  <Text style={styles.bodyFooterMapped}>
                    Nombre d'exemplaires souhaités : {" "}
                    {parseInt(requestSimu.pdfInputs["nombre_convention_honoraires"]).toLocaleString("en-EN").replace(/,/g, " ")}
                  </Text>
                  <Text style={styles.bodyFooterMapped}>
                    Objet de la convention : {" "}
                    { requestSimu.pdfInputs["object_convention_honoraires"] }
                  </Text>
                  <Text style={styles.bodyFooterMapped}>
                    Montant de la convention d'honoraires HT : {" "}
                    {parseInt(requestSimu.pdfInputs["montant_convention_honoraires"]).toLocaleString("en-EN").replace(/,/g, " ") +
                        " €"}
                  </Text>
                </>
                )
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Convention d'honoraires : non</Text>
              }
            } else if (key === "caisse_epargne") {
              if (requestSimu.inputs[key] === 1 && (requestSimu.simulateurid === 98 || requestSimu.simulateurid === 99)) {
                return <Text style={styles.bodyFooterMapped}>Prêt Caisse d'Epargne : Oui</Text>;
              }
            } else if (key === "montant_vente" && requestSimu.simulateurid !== 115) {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Montant de la vente :{" "}
                  {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                </Text>
              );
            } else if (key === "taux_accessoires" && simuPret.includes(requestSimu.simulateurid)) {
              if (getTauxAccessoiresForSimulateur(requestSimu.simulateurid) !== 20) {
                return <Text style={styles.bodyFooterMapped}>Taux des accessoires : {getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%</Text>;
              }
            } else if (key === "montant_meuble") {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Montant des meubles :{" "}
                  {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                </Text>
              );
            } else if (key === "montant_primo_accedant") {
              return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant primo-accédant :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
              );
            } else if (key === "montant_cautionnement") {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Montant du cautionnement :{" "}
                  {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                </Text>
              );
            } else if (key === "promesse") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <>
                    <Text style={styles.bodyFooterMapped}>Promesse : Oui {"\n"}</Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant de la promesse :{" "}
                      {parseInt(requestSimu.inputs["montant_promesse"]).toLocaleString("en-EN").replace(/,/g, " ") +
                        " €"}
                    </Text>
                  </>
                );
              }
            } else if (key === "debours_additionnels") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <>
                    <Text style={styles.bodyFooterMapped}>Débours additionnels : Oui {"\n"}</Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant débours additionnels :{" "}
                      {parseInt(requestSimu.inputs["montant_deb_add"]).toLocaleString("en-EN").replace(/,/g, " ") +
                        " €"}
                    </Text>
                  </>
                );
              }
            } else if (key === "pretHypo") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Prêt hypothécaire : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Prêt hypothécaire : Non</Text>;
              }
            } else if (key === "pretsPro") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Prêt aux professionels : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Prêt aux particuliers : Oui</Text>;
              }
            } else if (key === "sansGarantieHypo") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement sans garantie : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement sans garantie : Non</Text>;
              }
            } else if (key === "sansGarantieHypoPro") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement sans garantie pour prêts pro : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement sans garantie pour prêts pro : Non</Text>;
              }
            } else if (key === "avecGarantieHypo") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement avec garantie : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement avec garantie : Non</Text>;
              }
            } else if (key === "avecGarantieHypoPro") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement avec garantie pour prêts pro : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement avec garantie pour prêts pro : Non</Text>;
              }
            } else if (key === "montant_acquisition") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant de l'acquisition :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_retrocession") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant rétrocession ou substitution :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "pacte_preference") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Pacte de préférence : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Pacte de préférence : Non</Text>;
              }
            } else if (key === "action_resolutoire") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Action résolutoire ou droit de délaissement : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Action résolutoire ou droit de délaissement : Non</Text>;
              }
            } else if (key === "type_immeuble") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Type d'immeuble : En état d’achèvement ou neuf</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Type d'immeuble : Ancien</Text>;
              }
            } else if (key === "nombre_lots") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre de lots à créer, modifier ou supprimer : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "nombre_diagnostics") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre de diagnostics : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "montant_exigible") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant de la partie exigible :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "tva_concerne") {
              if (requestSimu.inputs[key] === 0.2) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA concerné : 20%</Text>;
              } else if (requestSimu.inputs[key] === 0.1) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA concerné : 10%</Text>;
              } else if (requestSimu.inputs[key] === 0.085) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA concerné : 8,5% (DOM)</Text>;
              } else if (requestSimu.inputs[key] === 0.055) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA concerné : 5,5%</Text>;
              } else if (requestSimu.inputs[key] === 0.021) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA concerné : 2,1% (DOM)</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA concerné : 0%</Text>;
              }
            } else if (key === "montant_lot_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant lot le plus élevé :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_lot_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant lot le plus faible :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_lot") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant lots 1 ou 2 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_meuble_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant des meubles :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_meuble_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant des meubles :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_licitee") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant de la part licitée :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_immeuble") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur totale de l’immeuble :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_acquis") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant des parts acquises :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_loyer_annuel") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant du loyer annuel :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "duree_bail") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Durée du bail : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "nombre_page_copie") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre de page(s) : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "montant_loyer") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant cumulé des loyers :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_residuelle") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur résiduelle des constructions :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_loyer_mensuel") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant du loyer mensuel :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_loyer_versements") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant annuel des loyers et versements :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nombre_diagnostic") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Nombre diagnostics immobiliers : {requestSimu.inputs[key]}
                  </Text>
                );
              }
            } else if (key === "montant_charges") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant cumulé des charges :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_honoraires") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant HT des honoraires :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_cession") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant fixé pour la cession :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "regime_cession") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Régime de la cession : Régime spécial</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Régime de la cession : Régime droit commun</Text>;
              }
            } else if (key === "acquisition_zone_geographique") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Acquisition en zone géographique spécifique : Oui</Text>;
              }
            } else if (key === "cession_fond_artisanal") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <Text style={styles.bodyFooterMapped}>Cession en pleine propriété d’un fonds artisanal : Oui</Text>
                );
              }
            } else if (key === "cession_fond_artisanal" && requestSimu.inputs["conditions_speciales"] === 1) {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Respect des conditions spéciales : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Respect des conditions spéciales : Non</Text>;
              }
            } else if (key === "acquisition_brevet") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Acquisition de brevet ou marque : Oui</Text>;
              }
            } else if (key === "brevet_vendu_seul" && requestSimu.inputs["acquisition_brevet"] === 1) {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Brevet vendu : Seul</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Brevet vendu : Avec le fonds</Text>;
              }
            } else if (key === "brevet_vendu_seul" && requestSimu.inputs["brevet_exploite"] === 1) {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Brevet exploité : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Brevet exploité : Non</Text>;
              }
            } else if (key === "marchandises_neuves") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Vente de marchandises neuves : Oui</Text>;
              }
            } else if (key === "nombre_servitude") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre servitudes : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "prix_acte") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Prix exprimé dans l'acte : Oui</Text>;
              }
            } else if (key === "valeur_servitude") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur servitude(s) à créer :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "facturation_forfait") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Facturation de plusieurs forfaits : Oui</Text>;
              } else {
                return <Text style={styles.bodyFooterMapped}>Facturation de plusieurs forfaits : Non</Text>;
              }
            } else if (key === "nombre_forfait") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre de forfaits : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "valeur_residuelle") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur résiduelle :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_venale") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur vénale :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "prix_cession") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Prix de cession :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_investissement") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant investissement :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "duree_bail") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Durée du contrat : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "nombre_copie_executoire") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre de pages : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "montant_loyer_mensuel_ht") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant HT mensuel des loyers :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "loyer_tva") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Loyers soumis à TVA : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Loyers soumis à TVA : Non</Text>;
              }
            } else if (key === "loyer_tva_taux" && requestSimu.inputs["loyer_tva"] === 1) {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA : 20%</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Taux de TVA : 5,5%</Text>;
              }
            } else if (key === "montant_frais_financier") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant des frais financiers :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "terrain_a_batir") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Terrain à batir : Oui</Text>;
              } else {
                return <Text style={styles.bodyFooterMapped}>Terrain à batir : Non</Text>;
              }
            } else if (key === "engagement_construire") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Engagement de construire : Oui</Text>;
              } else {
                return <Text style={styles.bodyFooterMapped}>Engagement de construire : Non</Text>;
              }
            } else if (key === "type_calcul") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Calcul : Depuis la base demandée par le vendeur</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Calcul : Depuis le prix comprenant les honoraires de négociation
                  </Text>
                );
              }
            } else if (key === "montant_forfait") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant forfaitaire minimum :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_demande") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant demandé :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "taux_remuneration") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Rémunération souhaitée :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "archivage") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Archivage : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Archivage : Non</Text>;
              }
            } else if (key === "valeur_transmise") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur transmise :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nombre_page") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre de pages : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "etat_civil") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Pièces d’état-civil demandées : Oui</Text>;
              }
            } else if (key === "comedec") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Recours à Comedec : Oui</Text>;
              }
            } else if (key === "nombre_comedec_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>Nombre de Comedec à 3,65€ : {requestSimu.inputs[key]}</Text>
                );
              }
            } else if (key === "nombre_comedec_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>Nombre de Comedec à 0,65€ : {requestSimu.inputs[key]}</Text>
                );
              }
            } else if (key === "nombre_copie_authentique") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Nombre pages "copie authentique" : {requestSimu.inputs[key]}
                  </Text>
                );
              }
            } else if (key === "nombre_copie_libre") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>Nombre pages "copie libre" : {requestSimu.inputs[key]}</Text>
                );
              }
            } else if (key === "nombre_archivage") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Nombre pages "archivage numérisé" : {requestSimu.inputs[key]}
                  </Text>
                );
              }
            } else if (key === "reserve_usufruit") {
              if (requestSimu.inputs[key] === 1) {
                if (requestSimu.inputs["age_usufruitier_2"] === 0) {
                  return (
                    <>
                      <Text style={styles.bodyFooterMapped}>Réserve d'usufruit : Oui {"\n"}</Text>
                      <Text style={styles.bodyFooterMapped}>Réserve d'usufruit : Oui {"\n"}</Text>
                      <Text style={styles.bodyFooterMapped}>
                        Âge de l'usufruitier : {requestSimu.inputs["age_usufruitier_1"]} ans
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Montant de l'usufruit :{" "}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "Usufruit_1") {
                              const montantNuePropriete = formatMontant(result[i].value);
                              return montantNuePropriete;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Montant de la nue-propriété :{" "}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "Nue_propriete_1") {
                              const montantNuePropriete = formatMontant(result[i].value);
                              return montantNuePropriete;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                    </>
                  );
                } else {
                  return (
                    <>
                      <Text style={styles.bodyFooterMapped}>Réserve d'usufruit : Oui {"\n"}</Text>
                      <Text style={styles.bodyFooterMapped}>
                        Âge du premier usufruitier : {requestSimu.inputs["age_usufruitier_1"]} ans {"\n"}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Âge du second usufruitier : {requestSimu.inputs["age_usufruitier_2"]} ans {"\n"}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Montant d'usufruit :{" "}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "Usufruit_1") {
                              const montantNuePropriete = formatMontant(result[i].value);
                              return montantNuePropriete;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Montant de nue-propriété :{" "}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "Nue_propriete_1") {
                              const montantNuePropriete = formatMontant(result[i].value);
                              return montantNuePropriete;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Montant d'usufruit :{" "}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "Usufruit_2") {
                              const montantNuePropriete = formatMontant(result[i].value);
                              return montantNuePropriete;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                      <Text style={styles.bodyFooterMapped}>
                        Montant de nue-propriété :{" "}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "Nue_propriete_2") {
                              const montantNuePropriete = formatMontant(result[i].value);
                              return montantNuePropriete;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                    </>
                  );
                }
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Réserve d'usufruit : Non</Text>;
              }
            } else if (key === "type_vente") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type d'immeuble : Hors copropriété
                  </Text>
                );
              } else if (requestSimu.inputs[key] === 2) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type d'immeuble : En copropriété
                  </Text>
                );
              } else if (requestSimu.inputs[key] === 3) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type d'immeuble : Terrain
                  </Text>
                );
              } else if (requestSimu.inputs[key] === 4) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type d'immeuble : Garage
                  </Text>
                );
              }
            } else if (key === "type_demembrement") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type de vente : Acquisition conjointe usufruit / nue-propriété
                  </Text>
                );
              } else if (requestSimu.inputs[key] === 2) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type de vente : Vente avec réserve d'usufruit ou droit d'usage et d'habitation sans rente
                  </Text>
                );
              } else if (requestSimu.inputs[key] === 3) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Type de vente : Vente d'usufruit
                  </Text>
                );
              }
            } else if (key === "us_fiscale") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur de l'usufruit fiscal :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "np_fiscale") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur de la nue-propriété fiscale :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "us_economique") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur de l'usufruit économique' :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "np_economique") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur de la nue-propriété économique' :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "reserve" && requestSimu.inputs["type_demembrement"] === 2 && requestSimu.inputs["np_economique"] !== 0) {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Réserve : De droit d'usage et d'habitation</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Réserve : D'usufruit</Text>;
              }
            } else if (key === "nombre_donateurs") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Nombre donateurs : Un donateur</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre donateurs : Deux donateurs</Text>;
              }
            } else if (key === "montant_donateur_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Masse donnée donateur 1 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_donateur_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Masse donnée donateur 2 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "donation_especes") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Donation d'espèces : Oui</Text>;
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Donation d'espèces : Non</Text>;
              }
            } else if (key === "montant_especes_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant espèces donateur 1 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_especes_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant espèces donateur 2 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nombre_spf") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre SPF : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "montant_fiscal_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Masse immobilière donnée donateur 1 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_fiscal_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Masse immobilière donnée donateur 2 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "reversion_usufruit") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Clause de réversion d'usufruit : Oui</Text>;
              } else {
                return <Text style={styles.bodyFooterMapped}>Clause de réversion d'usufruit : Non</Text>;
              }
            } else if (key === "DMTG") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <>
                    <Text style={styles.bodyFooterMapped}>Calcul des DMTG : Oui</Text>
                    <Text style={styles.bodyFooterMappedItalic}>
                      Vous trouverez le détail de votre calcul de DMTG ci-après
                    </Text>
                  </>
                );
              } else if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Calcul des DMTG : Non</Text>;
              }
            } else if (key === "nombre_donateurs") {
              if (requestSimu.inputs[key] === 1) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Donation : Cumulative si prédécès ou réalisée par un donateur
                  </Text>
                );
              } else if (requestSimu.inputs[key] === 2) {
                return <Text style={styles.bodyFooterMapped}>Donation : conjonctive</Text>;
              }
            } else if (key === "montant_rapports") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant donations antérieures à réincorporer :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_rapports_especes") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Dont espèces : {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_rapport_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <>
                    <Text style={styles.bodyFooterMapped}>
                      Montant rapports 1er donateur :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Dont espèces :{" "}
                      {parseInt(requestSimu.inputs["montant_rapport_especes_1"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </>
                );
              }
            } else if (key === "montant_rapport_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <>
                    <Text style={styles.bodyFooterMapped}>
                      Montant rapports 2ème donateur :{" "}
                      {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Dont espèces :{" "}
                      {parseInt(requestSimu.inputs["montant_rapport_especes_2"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </>
                );
              }
            } else if (key === "montant_donateur_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Somme donnée donateur 1 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_donateur_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Somme donnée donateur 2 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_NP_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant Nue-Propriété donnée donateur 1 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_NP_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant Nue-Propriété donnée donateur 2 :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_brut") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Actif brut de succession :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "total_rapportable") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant total des donations rapportables, de plus ou moins de 15 ans :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_passif") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Passif :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_net") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Actif net de succession :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            }else if (key === "montant_succession") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant de la succession :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "choix_meubles") {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Meubles meublants : {parseInt(requestSimu.inputs[key]) === 1
                    ? "Forfait mobilier (5% de l'actif brut)"
                    : "Valeur déterminée selon inventaire"}
                </Text>
              );
            } else if (key === "valeur_meubles") {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Valeur des meubles meublants :{" "}
                  {parseInt(requestSimu.inputs[key] || 0).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                </Text>
              );
            } else if (key === "montant_article757b") {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Primes taxables au titre de l’article 757B du CGI :{" "}
                  {parseInt(requestSimu.inputs[key] || 0).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                </Text>
              );
            } else if (key === "donations_rapportables") {
              return (
                <Text style={styles.bodyFooterMapped}>
                  Montant total des donations rapportables, qu'elles aient plus ou moins de 15 ans :{" "}
                  {parseInt(requestSimu.inputs[key] || 0).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                </Text>
              );
            } else if (key === "premier_deces") {
              if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Premier décès d’une communauté : Oui</Text>;
              } else if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Premier décès d’une communauté : Non</Text>;
              }
            } else if (key === "valeur_biens_communs") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens communs transmis :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_propres") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens propres transmis :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_transmis") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens transmis :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nombre_publicite_fonciere") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre SPF : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "valeur_biens_propres_1") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens propres 1er époux transmis :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_propres_2") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens propres 2nd époux transmis :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "masse_brute") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Masse brute partagée :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "actif_net") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Actif net partagé :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_cumulee") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur cumulée biens immobiliers partagés :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "droit_partage_reduit") {
              if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Droit partage concerné : Normal</Text>;
              } else if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Droit partage concerné : Réduit</Text>;
              }
            } else if (key === "montant_soulte") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant de la soulte :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_passif") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant du passif :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "codicilles") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Codicille(s) déposé(s) conservé(s) à l’étude : Oui</Text>;
              }
            } else if (key === "nombre_codicilles") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>Nombre de codicilles déposés : {requestSimu.inputs[key]}</Text>
                );
              }
            } else if (key === "envoi_possession") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Envoi en possession : Oui</Text>;
              }
            } else if (key === "valeur_bien") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur bien immobilier :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_declares") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens déclarés et/ou apportés :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "formalites_publication") {
              if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Formalités de publication au SPF : Oui</Text>;
              }
            } else if (key === "csi_volontaire") {
              if (requestSimu?.simulateurid === 76 && requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Base CSI volontaire :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_immo") {
              if (requestSimu?.simulateurid === 76) {
                return <></>;
              }
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur bien immobilier :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nombre_enfants") {
              if (requestSimu.inputs[key] > 0) {
                return <Text style={styles.bodyFooterMapped}>Nombre enfants majeurs : {requestSimu.inputs[key]}</Text>;
              }
            } else if (key === "montant_partage") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant actif brut à partager :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_partage_brut") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant actif brut à partager :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_partage_net") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant actif net partagé :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_partages") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens immobiliers partagés :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nombre_part_partage") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Nombre parts sociales faisant l’objet du partage partiel :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ")}
                  </Text>
                );
              }
            } else if (key === "nombre_parts_capital") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Nombre parts sociales composant le capital social :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ")}
                  </Text>
                );
              }
            } else if (key === "montant_honoraire") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant honoraire HT :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_biens_apportes") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur biens immobiliers apportés :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "valeur_spf") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Valeur bien apporté au SPF n°1 [n] :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "apport_pur_simple") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Dont apport à titre pur et simple :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "apport_onereux") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Dont apport à titre onéreux :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "pret_familial") {
              if (requestSimu.inputs[key] === 0){
                return <Text style={styles.bodyFooterMapped}>Prêt familial : Non</Text>;
              } else if (requestSimu.inputs[key] === 1){
                return <Text style={styles.bodyFooterMapped}>Prêt familial : Oui</Text>;
              }
            } else if (key === "pret_realise") {
              if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Prêt réalisé : Dans l'acte principal</Text>;
              } else if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Prêt réalisé : Par acte séparé</Text>;
              }
            } else if (key === "montant_pret") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant prêt ou capitaux empruntés :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_pret_hp") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant garanti par une hypothèque légale de préteur de deniers :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_pret_hc") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant garanti par l'Hypothèque Conventionnelle :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_pret") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant du prêt :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "cautionnement_realise") {
              if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement réalisé : Dans l'acte principal</Text>;
              } else if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Cautionnement réalisé : Par acte séparé</Text>;
              }
            } else if (key === "montant_cautionnement") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant cautionnement :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "nantissement_realise") {
              if (requestSimu.inputs[key] === 0) {
                return <Text style={styles.bodyFooterMapped}>Nantissement réalisé : Dans l'acte principal</Text>;
              } else if (requestSimu.inputs[key] === 1) {
                return <Text style={styles.bodyFooterMapped}>Nantissement réalisé : Par acte séparé</Text>;
              }
            } else if (key === "montant_nantissement") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant cautionnement :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_creance") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant créance :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_pouvoir") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Frais de pouvoir :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_quittance") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant quittance :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "montant_prorogation") {
              if (requestSimu.inputs[key] > 0) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant prorogation :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>
                );
              }
            } else if (key === "taux_accessoires" && simuPret.includes(requestSimu.simulateurid)) {
              if (getTauxAccessoiresForSimulateur(requestSimu.simulateurid) !== 20) {
                return <Text style={styles.bodyFooterMapped}>Taux des accessoires : {getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%</Text>;
              }
            }
            return <></>;
          })}

          {requestSimu.hasOwnProperty("dependances") ? (
            requestSimu?.dependances.map((dependance, index) => {
              if (servitudes.includes(requestSimu?.simulateurid) && requestSimu?.inputs["prix_acte"] === 1) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Prix de la servitude {index + 1} :{" "}
                    {parseInt(requestSimu?.dependances[index].prix_servitude)
                      .toLocaleString("en-EN")
                      .replace(/,/g, " ") + " €"}
                  </Text>
                );
              } else if (requestSimu?.simulateurid === 76) {
                return (
                  <View key={index}>
                    <Text style={styles.bodyFooterMapped}>
                      SPF {index + 1} - Époux 1 :{" "}
                      {parseInt(requestSimu?.dependances[index].epoux1 || 0).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      SPF {index + 1} - Époux 2 :{" "}
                      {parseInt(requestSimu?.dependances[index].epoux2 || 0).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant du SPF {index + 1} :{" "}
                      {parseInt(requestSimu?.dependances[index].valeur_spf || 0).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                    </Text>
                  </View>
                );
              } else if (valeurSPF.includes(requestSimu?.simulateurid)) {
                return (
                  <Text style={styles.bodyFooterMapped}>
                    Montant du SPF {index + 1} :{" "}
                    {parseInt(requestSimu?.dependances[index].valeur_spf).toLocaleString("en-EN").replace(/,/g, " ") +
                      " €"}
                  </Text>
                );
              } else if (dependance.simulateurid === 84) {
                return (
                  <View>
                    {requestSimu?.dependances[index].inputs["pret_realise"] === 1 ? (
                      <Text style={styles.bodyFooterMapped}>Prêt réalisé : Par acte séparé</Text>
                    ) : requestSimu?.dependances[index].inputs["pret_realise"] === 0 ? (
                      <Text style={styles.bodyFooterMapped}>Prêt réalisé : Dans l'acte principal</Text>
                    ) : (
                      <></>
                    )}
                    <Text style={styles.bodyFooterMapped}>
                      Montant prêt ou capitaux empruntés :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant garanti par une hypothèque légale de préteur de deniers :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret_hp"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant garanti par l'Hypothèque Conventionnelle :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret_hc"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </View>
                );
              } else if (dependance.simulateurid === 85) {
                return (
                  <View>
                    {requestSimu?.dependances[index].inputs["pret_realise"] === 1 ? (
                      <Text style={styles.bodyFooterMapped}>Prêt réalisé : Par acte séparé</Text>
                    ) : requestSimu?.dependances[index].inputs["pret_realise"] === 0 ? (
                      <Text style={styles.bodyFooterMapped}>Prêt réalisé : Dans l'acte principal</Text>
                    ) : (
                      <></>
                    )}
                    <Text style={styles.bodyFooterMapped}>
                      Montant total du prêt ou capitaux empruntés :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant du prêt soumis à un prêt aidé :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret_hp"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant garanti par l'Hypothèque Conventionnelle :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret_hc"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </View>
                );
              } else if (dependance.simulateurid === 92) {
                return (
                  <View>
                    {requestSimu?.dependances[index].inputs["pret_realise"] === 1 ? (
                      <Text style={styles.bodyFooterMapped}>Prêt réalisé : Par acte séparé</Text>
                    ) : requestSimu?.dependances[index].inputs["pret_realise"] === 0 ? (
                      <Text style={styles.bodyFooterMapped}>Prêt réalisé : Dans l'acte principal</Text>
                    ) : (
                      <></>
                    )}
                    <Text style={styles.bodyFooterMapped}>
                      Montant prêt ou capitaux empruntés :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant garanti par une hypothèque légale de préteur de deniers :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret_hp"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                    <Text style={styles.bodyFooterMapped}>
                      Montant garanti par l'Hypothèque Conventionnelle :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_pret_hc"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </View>
                );
              } else if (dependance.simulateurid === 89 || dependance.simulateurid === 96) {
                return (
                  <View>
                    {requestSimu?.dependances[index].inputs["cautionnement_realise"] === 1 ? (
                      <Text style={styles.bodyFooterMapped}>Acte de cautionnement réalisé : Par acte séparé</Text>
                    ) : requestSimu?.dependances[index].inputs["cautionnement_realise"] === 0 ? (
                      <Text style={styles.bodyFooterMapped}>Acte de cautionnement réalisé : Dans l'acte principal</Text>
                    ) : (
                      <></>
                    )}
                    <Text style={styles.bodyFooterMapped}>
                      Montant cautionnement sans garantie :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_cautionnement"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </View>
                );
              } else if (dependance.simulateurid === 90 || dependance.simulateurid === 97) {
                return (
                  <View>
                    {requestSimu?.dependances[index].inputs["cautionnement_realise"] === 1 ? (
                      <Text style={styles.bodyFooterMapped}>Acte de cautionnement réalisé : Par acte séparé</Text>
                    ) : requestSimu?.dependances[index].inputs["cautionnement_realise"] === 0 ? (
                      <Text style={styles.bodyFooterMapped}>Acte de cautionnement réalisé : Dans l'acte principal</Text>
                    ) : null}
                    <Text style={styles.bodyFooterMapped}>
                      Montant cautionnement avec garantie :{" "}
                      {parseInt(requestSimu?.dependances[index].inputs["montant_cautionnement"])
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ") + " €"}
                    </Text>
                  </View>
                );
              }
              return null;
            })
          ) : null}
          
          {/* Afficher les taux des accessoires pour les dépendances */}
          {simulateurObject?.data?.dependances?.map((dependance, index) => {
            const tauxDependance = dependance.inputs?.taux_accessoires ? parseFloat(dependance.inputs.taux_accessoires) : 20;
            if (tauxDependance !== 20 && simuPret.includes(dependance.simulateurid)) {
              // Vérifier si c'est un simulateur de cautionnement
              const isCautionnement = [90, 96, 97].includes(dependance.simulateurid);
              return <Text style={styles.bodyFooterMapped}>Taux des accessoires {isCautionnement ? 'cautionnement' : ''} : {tauxDependance}%</Text>;
            }
            return null;
          })}
        </View>

        <View style={styles.bodyFooterCtn} fixed>
          <Text style={styles.bodyFooterMedium}>
            IMPORTANT : Les informations et les résultats présentés ci-dessus sont donnés à titre indicatif et ne
            peuvent en aucun cas constituer un document à caractère contractuel. Les frais indiqués doivent être
            adressés par virement au minimum 48h-72h à l'avance.
          </Text>
          <Text style={styles.bodyFooterLight}>Sources : Éditions Langloÿs - Le Barème Rapide® {year}</Text>
        </View>
      </Page>

      {/*  P2  */}
      {(requestSimu?.simulateurid === 32 || requestSimu?.simulateurid === 83) ? null : (
        <Page size="A4" style={styles.page}>
          {requestSimu?.simulateurid === 32 || requestSimu?.simulateurid === 83 ? null : (
            <>
              <View style={[styles.themeTable, styles.container1]}>
                <View style={[styles.themeHeader, styles.container2]}>
                  <Text style={styles.themeHeaderText}>
                    DÉTAIL ÉMOLUMENTS HT
                  </Text>
                </View>

                  <>
                    <View
                      style={styles.persoEmolHeader}>
                      <Text style={styles.persoEmolHeaderText}>
                        ÉMOLUMENTS D’ACTE HT
                      </Text>
                    </View>

                    <View style={[styles.detailsContentTable, styles.detailsContentTableBorderBottom]}>
                      <View style={styles.detailsRow}>
                        <View style={styles.tresorHeaderLeft}/>

                        <View style={styles.tresorHeaderBaseCalc}>
                          <Text style={styles.container7Text1}>Base de calcul</Text>
                        </View>
                        <View style={styles.tresorHeaderBaseCalc}>
                          <Text style={styles.container7Text1}>Montant</Text>
                        </View>
                      </View>

                      {emolActeValues.map((value, index) => {
                        const baseEmolValue = baseEmolValues[index];
                        if (requestSimu?.simulateurid === 34 || requestSimu?.simulateurid === 35) {
                          return (
                            <View
                              key={index} style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Émoluments d’acte servitude {index + 1}
                                  {TblArticleValue !== null && (
                                    <>
                                      {" - "}
                                      {TblArticleValue}
                                    </>
                                  )}
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}>
                                <Text style={styles.detailsBaseText}>
                                  {baseEmolValue}
                                </Text>
                              </View>
                              <Text style={styles.detailsMontantText}>
                                {value}
                              </Text>
                            </View>
                          );
                        } else {
                          return <></>;
                        }
                      })}

                      {requestSimu.simulateurid === 39 ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Émoluments d’acte HT
                              {TblArticleValue !== null && (
                                <>
                                  {" - "}
                                  {TblArticleValue}
                                </>
                              )}
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}>
                            <Text style={styles.detailsBaseText}>
                              {(() => {
                                for (let i = 0; i < result.length; i++) {
                                  const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");

                                  if (emol1Value > emol2Value) {
                                    if (result[i].key === "base_emol_1") {
                                      return formattedValue + " €";
                                    }
                                  } else {
                                    if (result[i].key === "base_emol_2") {
                                      return formattedValue + " €";
                                    }
                                  }
                                }
                                return "";
                              })()}
                            </Text>
                          </View>
                          <Text style={styles.detailsMontantText}>
                            {(() => {
                              for (let i = 0; i < result.length; i++) {
                                const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");

                                if (emol1Value > emol2Value) {
                                  if (result[i].key === "emoluments_actes_1") {
                                    return formattedValue + " €";
                                  }
                                } else {
                                  if (result[i].key === "emoluments_actes_2") {
                                    return formattedValue + " €";
                                  }
                                }
                              }
                              return "";
                            })()}
                          </Text>
                        </View>
                      ) : (
                        <></>
                      )}

                {requestSimu.simulateurid === 115 ? (
                  <>
                    {simulateurObject.data.inputs.us_fiscale ||
                    simulateurObject.data.inputs.us_economique ? (
                      <View style={styles.detailsRow}>
                        <View style={styles.detailsSubjectField}>
                          <Text style={styles.detailsSubjectText}>
                            Émoluments d’acte de vente de l'usufruit HT
                            {TblArticleValue !== null && (
                              <>
                                {" - "}
                                {TblArticleValue}
                              </>
                            )}
                          </Text>
                        </View>
                        <View style={styles.detailsBaseField}>
                          <Text style={styles.detailsBaseText}>
                            {(() => {
                              for (let i = 0; i < result.length; i++) {
                                if (result[i].key === "base_emol_us") {
                                  return result[i].value;
                                }
                              }
                              return "";
                            })()}
                          </Text>
                        </View>
                        <Text style={styles.detailsMontantText}>
                          {(() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "emoluments_actes_us") {
                                return result[i].value;
                              }
                            }
                            return "";
                          })()}
                        </Text>
                      </View>
                    ) : null}
                    {simulateurObject.data.inputs.np_fiscale ||
                    simulateurObject.data.inputs.np_economique ? (
                      <View style={styles.detailsRow}>
                        <View style={styles.detailsSubjectField}>
                          <Text style={styles.detailsSubjectText}>
                            Émoluments d’acte de vente de la nue-propriété HT
                            {TblArticleValue !== null && (
                              <>
                                {" - "}
                                {TblArticleValue}
                              </>
                            )}
                          </Text>
                        </View>
                        <View style={styles.detailsBaseField}>
                          <Text style={styles.detailsBaseText}>
                            {(() => {
                              for (let i = 0; i < result.length; i++) {
                                if (result[i].key === "base_emol_np") {
                                  return result[i].value;
                                }
                              }
                              return "";
                            })()}
                          </Text>
                        </View>
                        <Text style={styles.detailsMontantText}>
                          {(() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "emoluments_actes_np") {
                                return result[i].value;
                              }
                            }
                            return "";
                          })()}
                        </Text>
                      </View>
                    ) : null}
                  </>
                ) : ((simulateurObject.data.inputs.montant_vente !== null &&
                  simulateurObject.data.inputs.montant_vente !== undefined) ||
                  (simulateurObject.data.inputs.montant_acquisition !== null &&
                    simulateurObject.data.inputs.montant_acquisition !== undefined) ||
                  (simulateurObject.data.inputs.montant_licitee !== null &&
                    simulateurObject.data.inputs.montant_licitee !== undefined)) &&
                requestSimu.hasOwnProperty("dependances") ? (
                  <View style={styles.detailsRow}>
                    <View style={styles.detailsSubjectField}>
                      <Text style={styles.detailsSubjectText}>
                        {simulateurObject.data.inputs.montant_vente
                          ? "Émoluments d’acte de vente HT"
                          : simulateurObject.data.inputs.montant_acquisition
                          ? "Émoluments d’acte d'acquisition HT"
                          : "Émoluments d’acte de licitation HT"}
                        {TblArticleValue !== null && (
                          <>
                            {" - "}
                            {TblArticleValue}
                          </>
                        )}
                      </Text>
                    </View>
                    <View style={styles.detailsBaseField}>
                      <Text style={styles.detailsBaseText}>
                        {requestSimu.simulateurid === 117 && requestSimu.inputs.type_viager === 1 ? 
                          parseInt(result.find(item => item.key === "base_emol")?.value)
                          .toLocaleString("en-EN").replace(/,/g, " ").toString() + " €"
                          :
                          parseInt(
                            (
                              simulateurObject.data.inputs.montant_vente ||
                              simulateurObject.data.inputs.montant_acquisition ||
                              simulateurObject.data.inputs.montant_licitee ||
                              0
                            ).toFixed(2)
                          ).toLocaleString("en-EN").replace(/,/g, " ").toString() + " €"
                        }
                      </Text>
                    </View>
                    <Text style={styles.detailsMontantText}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "emoluments_actes") {
                            return result[i].value;
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                ) : simulateurObject?.data?.inputs?.montant_donateur_1 !== null &&
                  simulateurObject?.data?.inputs?.montant_donateur_1 !== undefined ? (
                  <>
                    <View style={styles.detailsRow}>
                      <View style={styles.detailsSubjectField}>
                        <Text style={styles.detailsSubjectText}>
                          Émoluments d’acte - 1er donateur
                          {TblArticleValue !== null && (
                            <>
                              {" - "}
                              {TblArticleValue}
                            </>
                          )}
                        </Text>
                      </View>
                      <View style={styles.detailsBaseField}>
                        <Text style={styles.detailsBaseText}>
                          {(() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "base_emol_1") {
                                const formattedValue = parseInt(result[i].value)
                                  .toLocaleString("en-EN")
                                  .replace(/,/g, " ");
                                return (formattedValue + " €").toString();
                              }
                            }
                            return "";
                          })()}
                        </Text>
                      </View>
                      <Text style={styles.detailsMontantText}>
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "emoluments_actes_1") {
                              return result[i].value;
                            }
                          }
                          return "";
                        })()}
                      </Text>
                    </View>

                          {simulateurObject?.data?.inputs?.nombre_donateurs === 2 ? (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Émoluments d’acte - 2ème donateur
                                  {TblArticleValue !== null && (
                                    <>
                                      {" - "}
                                      {TblArticleValue}
                                    </>
                                  )}
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}>
                                <Text style={styles.detailsBaseText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "base_emol_2") {
                                        const formattedValue = parseInt(result[i].value)
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                              <Text style={styles.detailsMontantText}>
                                {(() => {
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "emoluments_actes_2") {
                                      return result[i].value;
                                    }
                                  }
                                  return "";
                                })()}
                              </Text>
                            </View>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {requestSimu?.simulateurid !== 34 &&
                            requestSimu?.simulateurid !== 35 &&
                            requestSimu?.simulateurid !== 32 &&
                            requestSimu?.simulateurid !== 83 &&
                            requestSimu?.simulateurid !== 39 && (
                              <>
                                <View style={styles.detailsRow}>
                                  <View style={styles.detailsSubjectField}>
                                    <Text style={[
                                      styles.detailsSubjectText,
                                      parseInt(simulateurObject?.data?.simulateurid) === 30 ? styles.detailsSubjectTextMedium: {},
                                    ]}>
                                      Émoluments d’acte HT
                                      {TblArticleValue !== null && (
                                          <>
                                            {" - "}
                                            {TblArticleValue}
                                          </>
                                      )}
                                    </Text>
                                  </View>
                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {(() => {
                                        for (let i = 0; i < result.length; i++) {
                                          if (result[i].key === "base_emol") {
                                            const formattedValue = parseInt(result[i].value)
                                                .toLocaleString("en-EN")
                                                .replace(/,/g, " ");
                                            return (formattedValue + " €").toString();
                                          }
                                        }
                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={[
                                    styles.detailsMontantText,
                                    parseInt(simulateurObject?.data?.simulateurid) === 30 ? styles.totalEmolFormValue : {},
                                  ]}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (
                                          ((parseInt(simulateurObject?.data?.simulateurid) === 30 || parseInt(simulateurObject?.data?.simulateurid) === 52) && result[i].key === "emoluments_actes_total") ||
                                          (parseInt(simulateurObject?.data?.simulateurid) !== 30 && result[i].key === "emoluments_actes")
                                        ) {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                {parseInt(simulateurObject?.data?.simulateurid) === 30 ? (
                                  <>
                                    {[1, 2, 3].map((emolIndex) => {
                                      const baseEmolValue = getResultValue(`base_emol_${emolIndex}`);
                                      const emolActeValue = getResultValue(`emoluments_actes_${emolIndex}`);

                                      if (isZeroEuroValue(baseEmolValue) && isZeroEuroValue(emolActeValue)) return null;

                                      return (
                                        <View key={`emoluments-actes-detail-${emolIndex}`} style={styles.detailsRow}>
                                          <View style={styles.detailsSubjectField}>
                                            <Text style={styles.detailsSubjectText}>
                                              Dont
                                            </Text>
                                          </View>
                                          <View style={styles.detailsBaseField}>
                                            <Text style={styles.detailsBaseText}>
                                              {baseEmolValue}
                                            </Text>
                                          </View>
                                          <Text style={styles.detailsMontantText}>
                                            {emolActeValue}
                                          </Text>
                                        </View>
                                      );
                                    })}
                                  </>
                                ) : <></>}
                                {requestSimu?.simulateurid === 10 || requestSimu?.simulateurid === 11 ? (
                                  <View style={styles.detailsRow}>
                                    <View style={styles.detailsSubjectField}>
                                      <Text style={styles.detailsSubjectText}>
                                        Dont émoluments d'acte fixes
                                      </Text>
                                    </View>
                                    <View style={styles.actePretTotalRightCol}>
                                      <Text style={styles.detailsBaseText}>
                                      </Text>
                                    </View>
                                    <Text style={styles.detailsMontantText}  >
                                      {(() => {
                                        for (let i = 0; i < result.length; i++) {
                                          if (result[i].key === "reglement_etablissement") {
                                            return result[i].value;
                                          }
                                        }
                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                ) : <></>
                                }
                              </>
                            )}
                        </>
                      )}

                      {isDependanceValid(simu84Index) || isDependanceValid(simu85Index) || isDependanceValid(simu92Index) ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Émoluments d’acte de prêt HT
                              {TblArticleValue !== null && (
                                <>
                                  {" - "}
                                  {DepsArticles[0]}
                                </>
                              )}
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}>
                            <Text style={styles.detailsBaseText}>
                              {isDependanceValid(simu84Index)
                                ? formattedBaseEmolValue84
                                : isDependanceValid(simu85Index)
                                ? formattedBaseEmolValue85
                                : isDependanceValid(simu92Index)
                                ? formattedBaseEmolValue92
                                : null}
                            </Text>
                          </View>
                          <Text style={styles.detailsMontantText}>
                            {isDependanceValid(simu84Index)
                              ? formattedEmolValue84
                              : isDependanceValid(simu85Index)
                              ? formattedEmolValue85
                              : isDependanceValid(simu92Index)
                              ? formattedEmolValue92
                              : null}
                          </Text>
                        </View>
                      ) : (
                        <></>
                      )}

                      {isDependanceValid(simu89Index) || isDependanceValid(simu96Index) || isDependanceValid(simu114Index) ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Émoluments d’acte de cautionnement sans garantie HT
                              {TblArticleValue !== null && (
                                <>
                                  {" - "}
                                  {DepsArticles[1]}
                                </>
                              )}
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}>
                            <Text style={styles.detailsBaseText}>
                              {isDependanceValid(simu89Index)
                                ? formattedBaseEmolValue89
                                : isDependanceValid(simu96Index)
                                ? formattedBaseEmolValue96
                                : isDependanceValid(simu114Index)
                                ? formattedBaseEmolValue114
                                : null}
                            </Text>
                          </View>
                          <Text style={styles.detailsMontantText}>
                            {isDependanceValid(simu89Index)
                              ? formattedEmolValue89
                              : isDependanceValid(simu96Index)
                              ? formattedEmolValue96
                              : isDependanceValid(simu114Index)
                              ? formattedEmolValue114
                              : null}
                          </Text>
                        </View>
                      ) : (
                        <></>
                      )}
                      {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Émoluments d’acte de cautionnement avec garantie HT
                              {TblArticleValue !== null && (
                                <>
                                  {" - "}
                                  {DepsArticles[2] ? DepsArticles[2] : DepsArticles[1]}
                                </>
                              )}
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}>
                            <Text style={styles.detailsBaseText}>
                              {isDependanceValid(simu90Index)
                                ? formattedBaseEmolValue90
                                : isDependanceValid(simu97Index)
                                ? formattedBaseEmolValue97
                                : null}
                            </Text>
                          </View>
                          <Text style={styles.detailsMontantText}>
                            {isDependanceValid(simu90Index)
                              ? formattedEmolValue90
                              : isDependanceValid(simu97Index)
                              ? formattedEmolValue97
                              : null}
                          </Text>
                        </View>
                      ) : (
                        <></>
                      )}

                      <View style={[styles.detailsRow, styles.detailsRowCompactBottom]}>
                        <View style={styles.totalEmolFormLeft}>
                          <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                            Total des émoluments d’acte HT (arrondi)
                          </Text>
                        </View>
                        <View style={styles.totalEmolFormMiddle}/>
                        <View style={styles.totalEmolFormRight}>
                          <Text style={styles.totalEmolFormValue}>
                            {requestSimu?.simulateurid !== 32 || requestSimu?.simulateurid !== 83
                              ? (() => {
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "emoluments_actes_total") {
                                      const numericValue = parseFloat(result[i].value);
                                      const roundedValue = Math.ceil(numericValue);
                                      const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                                      return (formattedValue + " €").toString();
                                    }
                                  }
                                  return "";
                                })()
                              : "0 €"}
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={styles.container43}>
                      <Text style={styles.persoEmolHeaderText}>
                        ÉMOLUMENTS DE FORMALITÉ HT
                      </Text>
                    </View>

                    <View style={[styles.detailsContentTable, styles.detailsContentTableBorderBottom]}>
                      {persoEmol === null ? (
                        <>
                          {((simulateurObject.data.inputs.montant_vente !== null &&
                            simulateurObject.data.inputs.montant_vente !== undefined) ||
                            (simulateurObject.data.inputs.montant_acquisition !== null &&
                              simulateurObject.data.inputs.montant_acquisition !== undefined) ||
                            (simulateurObject.data.inputs.montant_licitee !== null &&
                              simulateurObject.data.inputs.montant_licitee !== undefined)) &&
                          requestSimu.hasOwnProperty("dependances") ? (
                            //Simulateur 115 - option Acquisition conjointe
                            <>
                            {requestSimu.inputs.type_demembrement === 1 ?
                              <>
                              <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                                  
                                    <Text style={styles.container46Text}>
                                      Émoluments de formalités à la charge de l'usufruitier HT
                                    </Text>
                                  </View>
                                  <Text style={styles.container47Text2}>
                                    {(() => {
                                      const proportionUs = result.find(item => item.key === "proportion_us")?.value;
                                      return proportionUs;
                                    })()}
                                  </Text>
                                  <Text style={styles.container47Text}>
                                    {(() => {
                                      const emolFormUs = result.find(item => item.key === "emoluments_form_us")?.value;
                                      return emolFormUs;
                                    })()}
                                  </Text>
                                </View> 
                                <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                                    <Text style={styles.container46Text}>
                                      Émoluments de formalités à la charge du nu-propriétaire HT
                                    </Text>
                                  </View>
                                  <Text style={styles.container47Text2}>
                                    {(() => {
                                      const proportionNP = result.find(item => item.key === "proportion_np")?.value;
                                      return proportionNP;
                                    })()}
                                  </Text>
                                  <Text style={styles.container47Text}>
                                    {(() => {
                                      const emolFormNP = result.find(item => item.key === "emoluments_form_np")?.value;
                                      return emolFormNP;
                                    })()}
                                  </Text>
                                </View> 
                              </>
                              :
                              <>
                                <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                                    <Text style={styles.container46Text}>
                                      {`Émoluments de formalités HT ${emolFormValue === "-1 €" ? "(écrêtés)" : ""}`}
                                    </Text>
                                  </View>
                                  <View style={styles.promesseMiddle} />
                                  <Text style={styles.container47Text}>
                                    {(() => {
                                      const emolTotal = result.find(item => item.key === "Emol_total")?.value;
                                      const emolActes = result.find(item => item.key === "emoluments_actes_total")?.value;
                                      const emolForm = result.find(item => item.key === "Emol_Form")?.value;
                                      const emolFormalitesTotal = result.find(item => item.key === "emoluments_formalites_total")?.value ?? result.find(item => item.key === "Emol_Form_Total")?.value;

                                      if (emolFormValue === "-1 €" && emolTotal && emolActes) {
                                        const formalitesTotalNumber = parseFloat(emolFormalitesTotal);
                                        const formalitesEcretes =
                                          formalitesTotalNumber === -1 || isNaN(formalitesTotalNumber)
                                            ? parseFloat(emolTotal) - parseFloat(emolActes)
                                            : parseFloat(emolTotal) - parseFloat(emolActes) - formalitesTotalNumber;
                                        return formalitesEcretes.toFixed(2).replace('.', ',') + " €";
                                      }

                                      const numericValue = parseFloat(emolForm);
                                      return isNaN(numericValue) ? "0,00 €" : numericValue.toFixed(2).replace('.', ',') + " €";
                                    })()}
                                  </Text>
                                </View>  
                              </>
                            }
                            </>
                          ) : (
                            <View style={[styles.detailsRow, styles.detailsRowCompactTop]}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Émoluments de formalités HT
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>

                            <Text style={styles.detailsMontantText}>
                              {(() => {
                                const isPretAvecCaution =
                                  requestSimu?.simulateurid === 84 ||
                                  requestSimu?.simulateurid === 92;
                                for (let i = 0; i < result.length; i++) {
                                  if (isPretAvecCaution && result[i].key === "Emol_Form") {
                                    return result[i].value;
                                  }
                                  if (!isPretAvecCaution && result[i].key === "Emol_Form_Total") {
                                    return result[i].value;
                                  }
                                  if (!isPretAvecCaution && result[i].key === "emoluments_formalites_total") {
                                    return result[i].value;
                                  }
                                }
                                return "0 €";
                              })()}
                            </Text>
                            </View>
                          )}

                          {isDependanceValid(simu84Index) ||
                          isDependanceValid(simu85Index) ||
                          isDependanceValid(simu92Index) ? (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Émoluments de formalités acte de prêt HT
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>

                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu84Index)
                                  ? formattedEmolFormValue84
                                  : isDependanceValid(simu85Index)
                                  ? formattedEmolFormValue85
                                  : isDependanceValid(simu92Index)
                                  ? formattedEmolFormValue92
                                  : null}
                              </Text>
                            </View>
                          ) : (
                            <></>
                          )}

                          {isDependanceValid(simu89Index) || isDependanceValid(simu96Index) || isDependanceValid(simu114Index) ? (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Émoluments de formalités acte de cautionnement sans garantie HT
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>
                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu89Index)
                                  ? formattedEmolFormValue89
                                  : isDependanceValid(simu96Index)
                                  ? formattedEmolFormValue96
                                  : isDependanceValid(simu114Index)
                                  ? formattedEmolFormValue114
                                  : null}
                              </Text>
                            </View>
                          ) : (
                            <></>
                          )}

                          {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Émoluments de formalités acte de cautionnement avec garantie HT
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>
                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu90Index)
                                  ? formattedEmolFormValue90
                                  : isDependanceValid(simu97Index)
                                  ? formattedEmolFormValue97
                                  : null}
                              </Text>
                            </View>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <></>
                      )}

                      <View style={styles.container48} >
                        <View style={styles.totalEmolFormLeft}>
                          <Text style={styles.totalEmolFormText}>
                            {`Total des émoluments de formalités HT (arrondi) ${emolFormValue === "-1 €" ? "(écrêtés)" : ""}`}
                          </Text>
                        </View>
                        <View style={styles.totalEmolFormMiddle}/>
                        <View style={styles.totalEmolFormRight}>
                          <Text style={styles.totalEmolFormValue}>
                            {(() => {
                              const emolTotal = result.find(item => item.key === "Emol_total")?.value;
                              const emolActes = result.find(item => item.key === "emoluments_actes_total")?.value;
                              const emolFormTotal = result.find(r => r.key === "Emol_Form_Total")?.value;

                              if (emolFormValue === "-1 €" && emolTotal && emolActes) {
                                const formalitesEcretes = parseFloat(emolTotal) - parseFloat(emolActes);
                                return Math.ceil(formalitesEcretes).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                              }

                              const numericValue = parseFloat(emolFormTotal);
                              if (isNaN(numericValue)) return "0 €";
                              return Math.ceil(numericValue).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                            })()}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </>

                {/* END BLOC 2 */}

                {simulateurObject?.data?.inputs?.promesse === 1 ||
                simulateurObject?.data?.inputs?.promesse === "1" ? (
                  <View>
                      <View style={styles.detailsContentTable}>
                        <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                          <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                            <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                              Promesse de vente HT
                            </Text>
                          </View>
                          <View style={styles.totalEmolFormRight}/>
                          <View style={styles.promesseRight}>
                            <Text style={styles.totalEmolFormValue}>
                              {(() => {
                                for (let i = 0; i < result.length; i++) {
                                  if (result[i].key === "emol_promesse") {
                                    const formattedValue = parseInt(result[i].value)
                                      .toLocaleString("en-EN")
                                      .replace(/,/g, " ");
                                    return (formattedValue + " €").toString();
                                  }
                                }
                                return "";
                              })()}
                            </Text>
                          </View>
                        </View>
                      </View>
                  </View>
                ) : null}
              </View>
              {/* END BLOC 3 */}
              {persoEmol !== null ? (
                <View>
                  <View style={[styles.themeTable, styles.persoEmolMainContainer]}>
                    <View style={styles.persoEmolHeaderContainer}>
                      <Text style={styles.persoEmolHeaderText}>
                        DÉTAIL DES ÉMOLUMENTS DE FORMALITÉ HT SÉLECTIONNÉS
                      </Text>
                    </View>

                    <View style={styles.detailsContentTable}>
                      {1 !== null && 1 !== undefined ? (
                        <View style={styles.persoEmolColumnsHeader}>
                          <View style={styles.persoEmolColumn1Header}>
                            <Text style={styles.persoEmolColumn1HeaderText}>
                              Nature des formalités
                            </Text>
                          </View>
                          
                          <View style={styles.persoEmolColumn2Header}>
                            <Text style={styles.persoEmolColumn2HeaderTextTop}>
                              N° du Tableau 5
                            </Text>
                            <Text style={styles.persoEmolColumn2HeaderTextBottom}>
                              Article Arrêté
                            </Text>
                          </View>
                          <View style={styles.persoEmolColumn3Header}>
                            <Text style={styles.persoEmolColumnHeaderCenteredText}>
                              Coût de la formalité
                            </Text>
                          </View>
                          
                          <View style={styles.persoEmolColumn4Header}>
                            <Text style={styles.persoEmolColumnHeaderCenteredText}>
                              Nombre de formalités
                            </Text>
                          </View>
                        </View>
                      ) : (
                        <></>
                      )}

                      {persoEmol?.map((item, index) => {
                        return item.nombre > 0 ? (
                          <View style={index % 2 === 1 ? styles.persoEmolRowEven : styles.persoEmolRowOdd}>
                            <View style={styles.persoEmolItemNature}>
                              <Text style={styles.persoEmolItemNatureText}>
                                {item.formalite}
                              </Text>
                            </View>
                            <View style={styles.persoEmolItemNumero}>
                              <View style={styles.persoEmolItemNumeroWrapper}>
                                <Text style={styles.persoEmolItemNumeroText1}>
                                  {item.article.split("Art")[0]}
                                </Text>
                                <Text style={styles.persoEmolItemNumeroText2}>
                                  Art{item.article.split("Art")[1]}
                                </Text>
                              </View>
                            </View>
                            <View
                              style={styles.persoEmolItemCout}>
                              <View style={styles.persoEmolItemNumeroWrapper}>
                                <Text
                                  style={styles.persoEmolItemCoutText}>
                                  {item.montant} €
                                </Text>
                              </View>
                            </View>
                            <View
                              style={styles.persoEmolItemNombre}>
                              <View style={styles.persoEmolItemNumeroWrapper}>
                                <Text style= {styles.persoEmolItemCoutText}>
                                  {item.nombre}
                                </Text>
                              </View>
                            </View>
                          </View>
                        ) : (
                          <></>
                        );
                      })}

                      <View style={styles.persoEmolTotalRow}>
                        <View style={styles.persoEmolTotalLeft}>
                          <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                            Total des émoluments de formalités sélectionnés HT
                          </Text>
                        </View>
                        <View style={styles.persoEmolTotalRight}>
                          <Text style={styles.totalEmolFormValue}>
                            {parseInt(
                              (() => {
                                let tempo = 0;
                                for (let i = 0; i < persoEmol.length; i++) {
                                  if (persoEmol[i].nombre > 0) {
                                    tempo += parseFloat(parseInt(persoEmol[i].nombre) * parseFloat(persoEmol[i].montant));
                                  }
                                }
                                return tempo;
                              })().toFixed(2)
                            ) + " €"}
                          </Text>
                        </View>
                      </View>
                    </View>
                  </View>

                  <View style={styles.totalRow}>
                    <Text style={styles.totalText}>
                      TOTAL ÉMOLUMENTS HT
                    </Text>

                    <Text style={styles.totalText}>
                      {parseInt(
                        (
                          checkAndTransformNullToZero(
                            simulateurObject?.data?.dependances?.[simu84Index]?.output?.emoluments_actes_total
                          ) +
                          checkAndTransformNullToZero(
                            simulateurObject?.data?.dependances?.[simu92Index]?.output?.emoluments_actes_total
                          ) +
                          checkAndTransformNullToZero(
                            simulateurObject?.data?.dependances?.[simu89Index]?.output?.emoluments_actes_total
                          ) +
                          checkAndTransformNullToZero(
                            simulateurObject?.data?.dependances?.[simu90Index]?.output?.emoluments_actes_total
                          ) +
                          (() => {
                            for (let i = 0; i < result.length; i++) {
                              if (result[i].key === "emoluments_actes_total") {
                                return parseInt(result[i].value);
                              }
                            }
                            return 0;
                          })() +
                          (() => {
                            let tempo = 0;
                            for (let i = 0; i < persoEmol.length; i++) {
                              if (persoEmol[i].nombre > 0) {
                                tempo += parseFloat(parseInt(persoEmol[i].nombre) * parseFloat(persoEmol[i].montant));
                              }
                            }
                            return tempo;
                          })()
                        ).toFixed(2)
                      )
                        .toLocaleString("en-EN")
                        .replace(/,/g, " ")
                        .toString() + " €"}
                    </Text>
                  </View>
                </View>
              ) : (
                <></>
              )}
              {persoEmol === null ? (
                <>
                <View style={styles.totalRow}>
                  <Text style={[styles.totalText, styles.totalTextMedium]}>
                    TOTAL ÉMOLUMENTS HT (arrondi)
                  </Text>

                  <Text style={styles.totalText}>
                    {(() => {
                      for (let i = 0; i < result.length; i++) {
                        if (result[i].key === "Emol_total") {
                          const numericValue = parseFloat(result[i].value);
                          const roundedValue = Math.ceil(numericValue);
                          const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                          const montantFinal= (formattedValue + (" €").toString());
                          return emolFormValue === "-1 €"
                          ? `${montantFinal} (après écrêtement)`
                          : montantFinal;
                        }
                      }
                      return "";
                    })()}
                  </Text>
                </View>
                {requestSimu.simulateurid === 115 && requestSimu.inputs.type_demembrement === 1 ? (
                  <>
                    <View style={[styles.totalRow, styles.totalUsufructRowCustom]}>
                      <Text style={[styles.totalText, styles.totalUsufructTextCustom]}>
                        Total émoluments à la charge de l'usufruitier HT (arrondi)
                      </Text>

                      <Text style={[styles.totalText, styles.totalUsufructAmountCustom]}>
                        {(() => {
                          const emolumentsActesUs = parseFloat(result.find(item => item.key === "emoluments_actes_us")?.value || 0)
                          const emolumentsFormsUs = parseFloat(result.find(item => item.key === "emoluments_form_us")?.value || 0)
                          const emolumentsPromesseUs = parseFloat(result.find(item => item.key === "emoluments_promesse_us")?.value || 0)
                          const totalEmolumentsUs = Math.ceil(emolumentsActesUs + emolumentsFormsUs + emolumentsPromesseUs).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                          return totalEmolumentsUs;
                        })()}
                      </Text>
                    </View>

                    <View style={[styles.totalRow, styles.totalNPRowCustom]}>
                      <Text style={[styles.totalText, styles.totalUsufructTextCustom]}>
                        Total émoluments à la charge du nu-propriétaire HT (arrondi)
                      </Text>

                      <Text style={[styles.totalText, styles.totalUsufructAmountCustom]}>
                        {(() => {
                          const emolumentsActesNP = parseFloat(result.find(item => item.key === "emoluments_actes_np")?.value || 0)
                          const emolumentsFormsNP = parseFloat(result.find(item => item.key === "emoluments_form_np")?.value || 0)
                          const emolumentsPromesseNP = parseFloat(result.find(item => item.key === "emoluments_promesse_np")?.value || 0)
                          const totalEmolumentsNP = Math.ceil(emolumentsActesNP + emolumentsFormsNP + emolumentsPromesseNP).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                          return totalEmolumentsNP;
                        })()}
                      </Text>
                    </View>
                  
                  </>
                ) : null}
                </>
              ) : null}
            </>
          )}

          <View style={styles.bodyFooterCtn} fixed>
            <Text style={styles.bodyFooterMedium}>
              IMPORTANT : Les informations et les résultats présentés ci-dessus sont donnés à titre indicatif et ne
              peuvent en aucun cas constituer un document à caractère contractuel. Les frais indiqués doivent être
              adressés par virement au minimum 48h-72h à l'avance.
            </Text>
            <Text style={styles.bodyFooterLight}>Sources : Éditions Langloÿs - Le Barème Rapide® {year}</Text>
          </View>
        </Page>
      )}
      {/*  END P2  */}
      {/*  P3  */}
      <Page>
        <View style={[styles.themeTable, styles.fiscaliteTableContainer]}>
          <View style={[styles.themeHeader, styles.fiscaliteTableHeader]}>
            <Text style={styles.themeHeaderText}>
              DÉTAIL FISCALITÉ
            </Text>
          </View>

          <View style={styles.fiscaliteSectionHeader}>
            <Text style={styles.persoEmolHeaderText}>
              TVA SUR ÉMOLUMENTS
            </Text>
          </View>

          <View style={styles.detailsContentTable}>
                <View style={[styles.detailsRow, styles.tvaRowContainer]}>
              <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                    TVA sur émoluments (arrondi)
                </Text>
              </View>
              <View style={styles.promesseRight}/>
              <View style={styles.promesseRight}>
                <Text style={styles.totalEmolFormValue}>
                  {(() => {
                    for (let i = 0; i < result.length; i++) {
                      if (result[i].key === "TVA_total") {
                        const numericValue = parseFloat(result[i].value) - (requestSimu.pdfInputs['montant_convention_honoraires'] * tauxTva);
                        const roundedValue = Math.ceil(numericValue);
                        const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                        return (formattedValue + " €").toString();
                      }
                    }
                    return "";
                  })()}
                </Text>
              </View>
            </View>
          </View>

          <View
            style={styles.fiscaliteSectionHeader}>
            <Text
              style={styles.persoEmolHeaderText}>
              DÉTAIL DROITS DUS AU TRÉSOR PUBLIC
            </Text>
          </View>

          {result.map((object) => {
            if (object.key === "Tresor_total" && object.value !== "0 €") {
              return (
                <>
                  {tresorTotalValue !== droitEtatValue ? (
                    <>
                      <View style={[styles.detailsContentTable, styles.detailsContentTableBorderBottom]}>
                        <View style={styles.detailsRow}>
                          <View
                            style={styles.tresorHeaderEmptyColumn}/>

                          <View style={styles.tresorHeaderBaseCalc}>
                            <Text style={styles.container7Text1}>
                              Base de calcul
                            </Text>
                          </View>
                          <View style={styles.tresorHeaderBaseCalc}>
                            <Text style={styles.container7Text1}>
                              Montant
                            </Text>
                          </View>
                        </View>

                        {((simulateurObject.data.inputs.montant_vente !== null &&
                        simulateurObject.data.inputs.montant_vente !== undefined) ||
                        (simulateurObject.data.inputs.montant_licitee !== null &&
                        simulateurObject.data.inputs.montant_licitee !== undefined)) &&
                        requestSimu.hasOwnProperty("dependances") ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                                Droits dus au trésor : acte de {simuLicitation.includes(requestSimu.simulateurid) ? "licitation" : "vente"}
                              </Text>
                            </View>
                            {simulateurObject.data.inputs.acte_en_main === 1 ? (
                              <>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTresorValue = null;
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_tresor") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }
                                      if (baseTresorValue !== null) {
                                        const formattedValue = baseTresorValue
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      } else {
                                        <></>;
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={[styles.detailsMontantText, styles.detailsMontantTextBold]}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "Tresor") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </>
                            ) : (
                              <>
                                <View style={styles.detailsBaseField}/>
                                <Text style={[styles.detailsMontantText, styles.detailsMontantTextBold]}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "Tresor") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </>
                            )}
                          </View>
                        ) : simuPret.includes(requestSimu.simulateurid) ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                                Droits dus au trésor : acte de {simuCautionnement.includes(requestSimu.simulateurid) ? "cautionnement" : "prêt"}
                              </Text>
                            </View>
                            <View style={styles.detailsBaseField}/>
                            <Text style={[styles.detailsMontantText, styles.detailsMontantTextBold]}>
                              {(() => {
                                for (let i = 0; i < result.length; i++) {
                                  if (result[i].key === "Tresor") {
                                    return result[i].value;
                                  }
                                }
                                return "";
                              })()}
                            </Text>
                          </View>
                        ) : (
                          <View style={styles.detailsRow}>
                            <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH5]}></View>
                            <View style={styles.tresorEmptyMiddle}/>
                          </View>
                        )}
                        {result.map((object) => {
                          if (
                              object.key === "droit_mutation_primo" &&
                              requestSimu?.simulateurid !== 34 &&
                              requestSimu?.simulateurid !== 35
                          ) {
                            return (
                                <View style={styles.detailsRow}>
                                  {renderDMTO(result, true, true)}

                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {(() => {
                                        let baseDmtoValue = null;

                                        for (let i = 0; i < result.length; i++) {
                                          if (result[i].key === "base_primo_accedant") {
                                            baseDmtoValue = parseInt(result[i].value);
                                          }
                                        }
                                        if (baseDmtoValue !== null) {
                                          const formattedValue = baseDmtoValue
                                              .toLocaleString("en-EN")
                                              .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={styles.detailsMontantText}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "droit_mutation_primo") {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {result.map((object) => {
                          if (
                            object.key === "droit_mutation" &&
                            requestSimu?.simulateurid !== 34 &&
                            requestSimu?.simulateurid !== 35
                          ) {
                            let primoPresent = result.find((item) => item.key === "droit_mutation_primo")
                            return (
                              <View style={styles.detailsRow}>
                                {renderDMTO(result, primoPresent, false)}

                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseDmtoValue = null;
                                      let baseTresorValue = null;

                                      if (primoPresent) {
                                        baseDmtoValue = parseInt(result.find((item) => item.key === "base_tresor")?.value)
                                            - parseInt(result.find((item) => item.key === "base_primo_accedant")?.value);
                                      } else {
                                        for (let i = 0; i < result.length; i++) {
                                          if (result[i].key === "base_droit_mutation") {
                                            baseDmtoValue = parseInt(result[i].value);
                                          }
                                          if (result[i].key === "base_tresor") {
                                            baseTresorValue = parseInt(result[i].value);
                                          }
                                        }
                                      }

                                      if (baseDmtoValue === null) {
                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      } else {
                                        if (baseDmtoValue !== null) {
                                          const formattedValue = baseDmtoValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "droit_mutation") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        <>
                          {result.map((object) => {
                            if (object.key === "dmto_usufruitier") {
                              return (
                                <View style={styles.detailsRow}>
                                  {renderDMTO(result, false, false)}
                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {(() => {
                                        let baseDmtoValue = parseInt(simulateurObject.data.inputs.us_fiscale);
                                        if (baseDmtoValue !== 0) {
                                          const formattedValue = baseDmtoValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={styles.detailsMontantText}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "dmto_usufruitier") {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                              );
                            } else {
                              return <></>;
                            }
                          })}
                        </>
                        <>
                          {result.map((object) => {
                            if (object.key === "dmto_nu_proprietaire") {
                              return (
                                <View style={styles.detailsRow}>
                                  {renderDMTO(result, false, false)}
                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {/* SI RESERVE = 1, np_economique */}
                                      {(() => {
                                        let baseDmtoValue = null;
                                        if (simulateurObject.data.inputs.reserve) {
                                          baseDmtoValue = parseInt(simulateurObject.data.inputs.np_economique);
                                        } else {
                                          baseDmtoValue = parseInt(simulateurObject.data.inputs.np_fiscale);
                                        }
                                        if (baseDmtoValue !== null) {
                                          const formattedValue = baseDmtoValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={styles.detailsMontantText}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "dmto_nu_proprietaire") {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                              );
                            } else {
                              return <></>;
                            }
                          })}
                        </>
                        
                        {dmtoValues.map((value, index) => {
                          const baseTresorValue = baseTresorValues[index];
                          if (requestSimu?.simulateurid === 34 || requestSimu?.simulateurid === 35) {
                            return (
                              <View
                                key={index}
                                style={styles.detailsRow}
                              >
                                <View style={styles.detailsSubjectField}>
                                  <Text key={index} style={styles.detailsSubjectText} >
                                    {simulateurObject?.data?.inputs?.prix_acte === 0 &&
                                    (requestSimu.departementid === 36 || requestSimu.departementid === 56) ? (
                                      `Dont DMTO`
                                    ) : simulateurObject?.data?.inputs?.prix_acte === 1 &&
                                      (requestSimu.departementid === 36 || requestSimu.departementid === 56) ? (
                                      `Dont DMTO (5,09006%) servitude ${index + 1}`
                                    ) : simulateurObject?.data?.inputs?.prix_acte === 0 ? (
                                      `Dont DMTO`
                                    ) : simulateurObject?.data?.inputs?.prix_acte === 1 ? (
                                      `Dont DMTO (5,80665%) servitude ${index + 1}`
                                    ) : (
                                      <></>
                                    )}
                                  </Text>
                                </View>

                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {simulateurObject?.data?.inputs?.prix_acte === 1 ? <>{baseTresorValue}</> : <></>}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {value}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {result.map((object) => {
                          if (object.key === "tpf") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    {simuPret.includes(requestSimu.simulateurid)
                                      ? `Dont TPF (0,71498%) (base de calcul majorée des accessoires ${getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%)`
                                      : simuDonation.includes(requestSimu.simulateurid)
                                      ? "Dont TPF (0,61422%)"
                                      : "Dont TPF (0,71498%)"}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTpfValue = null;
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_tpf") {
                                          baseTpfValue = parseInt(result[i].value);
                                        }
                                        if (result[i].key === "base_tresor") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTpfValue === null) {
                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      } else {
                                        if (baseTpfValue !== null) {
                                          const formattedValue = baseTpfValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "tpf") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {result.map((object) => {
                          if (object.key === "droit_partage") {
                            return (
                              <View style={styles.detailsRow}>
                                {renderDroitDePartage()}

                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let basePartageValue = null;
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_droit_partage") {
                                          basePartageValue = parseInt(result[i].value);
                                        }
                                        if (result[i].key === "base_tresor") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (basePartageValue === null) {
                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      } else {
                                        if (basePartageValue !== null) {
                                          const formattedValue = basePartageValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "droit_partage") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (result[i].key === "droit_echange") {
                              return (
                                <View style={styles.detailsRow}>
                                  <View style={styles.detailsSubjectField}>
                                    <Text style={styles.detailsSubjectText}>
                                      Dont droit échange (5%)
                                    </Text>
                                  </View>
                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {(() => {
                                        let baseTresorValue = null;

                                        for (let i = 0; i < result.length; i++) {
                                          if (result[i].key === "base_droit_echange") {
                                            baseTresorValue = parseInt(result[i].value);
                                          }
                                        }

                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }

                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={styles.detailsMontantText}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "droit_echange") {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                              );
                            }
                          }
                          return "";
                        })()}
                        {result.map((object) => {
                          if (
                            object.key === "csi_publication" &&
                            requestSimu?.simulateurid !== 18 &&
                            requestSimu?.simulateurid !== 21 &&
                            requestSimu?.simulateurid !== 34 &&
                            requestSimu?.simulateurid !== 35 &&
                            requestSimu?.simulateurid !== 81 &&
                            requestSimu?.simulateurid !== 82 &&
                            csiPublicationSpfRows.length === 0
                          ) {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    {hasCsiVolontaire && parseCurrencyValue(object.value) === 15
                                      ? "Dont CSI fixe de publication volontaire"
                                      : hasCsiVolontaire
                                      ? "Dont CSI de publication volontaire (0,10%)"
                                      : parseCurrencyValue(object.value) === 15
                                      ? "Dont CSI fixe"
                                      : "Dont CSI de publication (0,10%)"}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseCsiPubliValue = null;
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_csi_publication") {
                                          baseCsiPubliValue = parseInt(result[i].value);
                                        }
                                        if (result[i].key === "base_tresor") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseCsiPubliValue === null) {
                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      } else {
                                        if (baseCsiPubliValue !== null) {
                                          const formattedValue = baseCsiPubliValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "csi_publication") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {csiPublicationSpfRows.map((row) => (
                          <View
                            key={`csi-publication-spf-${row.index}`}
                            style={styles.detailsRow}
                          >
                            <View style={styles.detailsSubjectField}>
                              <Text style={styles.detailsSubjectText}>
                                {row.isCsiVolontaire && parseCurrencyValue(row.amount) === 15
                                  ? `Dont CSI fixe de publication volontaire SPF n°${row.index + 1}`
                                  : row.isCsiVolontaire
                                  ? `Dont CSI de publication volontaire (0,10%) SPF n°${row.index + 1}`
                                  : `Dont CSI de publication (0,10%) SPF n°${row.index + 1}`}
                              </Text>
                            </View>
                            <View style={styles.detailsBaseField}>
                              <Text style={styles.detailsBaseText}>
                                {formatMontant(row.base)}
                              </Text>
                            </View>
                            <Text style={styles.detailsMontantText}>
                              {row.amount}
                            </Text>
                          </View>
                        ))}
                        {result.map((object) => {
                          //console.log(object, "object test")
                          if (object.key === "taxe_ile_de_france") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont taxe additionnelle
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTaxeAdd = null;
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "taxe_ile_de_france") {
                                          baseTaxeAdd = parseInt(result[i].value);
                                        }
                                        if (result[i].key === "base_tresor") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTaxeAdd === null) {
                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      } else {
                                        if (baseTaxeAdd !== null) {
                                          const formattedValue = baseTaxeAdd
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "taxe_ile_de_france") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (
                              result[i].key === "csi_publication_1" &&
                              !valeurSPF.includes(requestSimu.simulateurid) &&
                              !servitudes.includes(requestSimu.simulateurid)
                            ) {
                              return (
                                <View style={styles.detailsRow}>
                                  <View style={styles.detailsSubjectField}>
                                    <Text style={styles.detailsSubjectText}>
                                      {simulateurObject?.data?.inputs?.nombre_donateurs === 2
                                        ? "Dont CSI de publication 1er donateur (0,10%)"
                                        : requestSimu?.simulateurid === 18 || requestSimu?.simulateurid === 21
                                        ? "Dont CSI de publication sur le lot le plus élevé (0,10%)"
                                        : "Dont CSI de publication (0,10%)"}
                                    </Text>
                                  </View>
                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {(() => {
                                        let baseTresorValue = null;

                                        for (let i = 0; i < result.length; i++) {
                                          if (
                                            result[i].key === "base_tresor_1" ||
                                            result[i].key === "base_csi_publication_1"
                                          ) {
                                            baseTresorValue = parseInt(result[i].value);
                                          }
                                        }

                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }

                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={styles.detailsMontantText}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "csi_publication_1") {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                              );
                            }
                          }
                          return "";
                        })()}
                        {(() => {
                          for (let i = 0; i < result.length; i++) {
                            if (
                              result[i].key === "csi_publication_2" &&
                              !valeurSPF.includes(requestSimu.simulateurid) &&
                              !servitudes.includes(requestSimu.simulateurid)
                            ) {
                              return (
                                <View style={styles.detailsRow}>
                                  <View style={styles.detailsSubjectField}>
                                    <Text style={styles.detailsSubjectText}>
                                      {requestSimu?.simulateurid === 18 || requestSimu?.simulateurid === 21
                                        ? "Dont CSI de publication sur le lot le plus faible (0,10%)"
                                        : "Dont CSI de publication 2ème donateur (0,10%)"}
                                    </Text>
                                  </View>
                                  <View style={styles.detailsBaseField}>
                                    <Text style={styles.detailsBaseText}>
                                      {(() => {
                                        let baseTresorValue = null;

                                        for (let i = 0; i < result.length; i++) {
                                          if (
                                            result[i].key === "base_tresor_2" ||
                                            result[i].key === "base_csi_publication_2"
                                          ) {
                                            baseTresorValue = parseInt(result[i].value);
                                          }
                                        }

                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }

                                        return "";
                                      })()}
                                    </Text>
                                  </View>
                                  <Text style={styles.detailsMontantText}>
                                    {(() => {
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "csi_publication_2") {
                                          return result[i].value;
                                        }
                                      }
                                      return "";
                                    })()}
                                  </Text>
                                </View>
                              );
                            }
                          }
                          return "";
                        })()}
                        {csiPublicationValues.map((value, index) => {
                          const baseTresorValue = baseTresorValues[index];
                          if (requestSimu?.simulateurid === 34 || requestSimu?.simulateurid === 35) {
                            return (
                              <View
                                key={index}
                                style={styles.detailsRow}
                              >
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    {simulateurObject?.data?.inputs?.prix_acte === 0 || simulateurObject?.data?.inputs?.prix_acte === "0"
                                      ? `Dont CSI de publication (0,10%)`
                                      : `Dont CSI de publication (0,10%) servitude ${index + 1}`}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {baseTresorValue}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {value}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}
                        {csiPublicationValues.map((value, index) => {
                          const baseTresorValue = baseTresorValues[index];
                          if (requestSimu?.simulateurid === 81) {
                            return (
                              <View
                                key={index}
                                style={styles.detailsRow}
                              >
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont CSI de publication (0,10%) SPF n°
                                    {index + 1}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {baseTresorValue}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {value}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}

                        {csiPublicationValues.map((value, index) => {
                          const baseCsiValue = baseCsiValues[index];
                          if (requestSimu?.simulateurid === 82) {
                            return (
                              <View
                                key={index}
                                style={styles.detailsRow}
                              >
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont CSI de publication (0,10%) SPF n°
                                    {index + 1}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {baseCsiValue}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {value}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}

                        {result.map((object) => {
                          if (object.key === "droit_donation_1") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    {simulateurObject?.data?.inputs?.nombre_donateurs === 2
                                      ? "Dont TPF 1er donateur (0,61422%)"
                                      : "Dont TPF (0,61422%)"}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_tresor_1") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTresorValue !== null) {
                                        const formattedValue = baseTresorValue
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "droit_donation_1") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}

                        {result.map((object) => {
                          if (object.key === "droit_donation_2") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont TPF 2ème donateur (0,61422%)
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_tresor_2") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTresorValue !== null) {
                                        const formattedValue = baseTresorValue
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "droit_donation_2") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return <></>;
                          }
                        })}

                        {result.map((object) => {
                          if (object.key === "droit_partage_rapport") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont droits de partage (2,50%) sur le montant des rapports
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "rapport_total") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTresorValue !== null) {
                                        const formattedValue = baseTresorValue
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "droit_partage_rapport") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return null;
                          }
                        })}
                        {result.map((object) => {
                          if (object.key === "csi_inscription") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    {simuPret.includes(requestSimu.simulateurid)
                                      ? `Dont CSI d'inscription (0,05%) (base de calcul majorée des accessoires ${getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%)`

                                      : "Dont CSI d'inscription (0,05%)"}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseCsiInscrValue = null;
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_csi_inscription") {
                                          baseCsiInscrValue = parseInt(result[i].value);
                                        }
                                        if (result[i].key === "base_tresor") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseCsiInscrValue === null) {
                                        if (baseTresorValue !== null) {
                                          const formattedValue = baseTresorValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      } else {
                                        if (baseCsiInscrValue !== null) {
                                          const formattedValue = baseCsiInscrValue
                                            .toLocaleString("en-EN")
                                            .replace(/,/g, " ");
                                          return (formattedValue + " €").toString();
                                        }
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "csi_inscription") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return null;
                          }
                        })}
                        {result.map((object) => {
                          if (object.key === "csi_publication_usufruit") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont CSI de publication (0,10%) sur l'usufruit le plus élevé
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTresorValue = null;

                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "usufruit_retenu") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTresorValue !== null) {
                                        const formattedValue = baseTresorValue
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "csi_publication_usufruit") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return null;
                          }
                        })}
                        {requestSimu.simulateurid === 32 ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={styles.detailsSubjectText}>
                                Dont droit d'enregistrement pour une cession de fonds de commerce
                              </Text>
                            </View>
                            <View style={styles.detailsBaseField}>
                              <Text style={styles.detailsBaseText}>
                                {(() => {
                                  let baseTresorValue = null;
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "base_tresor") {
                                      baseTresorValue = parseInt(result[i].value);
                                    }
                                  }

                                  if (baseTresorValue !== null) {
                                    const formattedValue = baseTresorValue.toLocaleString("en-EN").replace(/,/g, " ");
                                    return (formattedValue + " €").toString();
                                  }

                                  return "";
                                })()}
                              </Text>
                            </View>
                            <Text style={styles.detailsMontantText}>
                              {(() => {
                                for (let i = 0; i < result.length; i++) {
                                  if (result[i].key === "Tresor_total") {
                                    const formattedValue = parseInt(result[i].value)
                                      .toLocaleString("en-EN")
                                      .replace(/,/g, " ");
                                    return (formattedValue + " €").toString();
                                  }
                                }
                                return "";
                              })()}
                            </Text>
                          </View>
                        ) : null}
                        {result.map((object) => {
                          if (object.key === "csi_publication_rapport") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont CSI de publication (0,10%) sur le montant des rapports (hors espèces)
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}>
                                    {(() => {
                                      let baseTresorValue = null;
                                      for (let i = 0; i < result.length; i++) {
                                        if (result[i].key === "base_csi_publication_rapport") {
                                          baseTresorValue = parseInt(result[i].value);
                                        }
                                      }

                                      if (baseTresorValue !== null) {
                                        const formattedValue = baseTresorValue
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }

                                      return "";
                                    })()}
                                  </Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "csi_publication_rapport") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return null;
                          }
                        })}
                        {result.map((object) => {
                          if (object.key === "DMTG") {
                            return (
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    Dont DMTG
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}>
                                  <Text style={styles.detailsBaseText}></Text>
                                </View>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "DMTG") {
                                        return result[i].value;
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>
                            );
                          } else {
                            return null;
                          }
                        })}
                        {isDependanceValid(simu84Index) ||
                        isDependanceValid(simu85Index) ||
                        isDependanceValid(simu92Index) ? (
                          <View style={styles.detailsRow}>
                            <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldBorderTop]}>
                              <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                                Droits dus au trésor : acte de prêt
                              </Text>
                            </View>
                            <View style={styles.Actepret1}/>
                            <View style={styles.actePretTotalRightCol}>
                              <Text
                                style={styles.baseRightCol}>
                                {isDependanceValid(simu84Index)
                                  ? formattedTresorTotal84
                                  : isDependanceValid(simu85Index)
                                  ? formattedTresorTotal85
                                  : isDependanceValid(simu92Index)
                                  ? formattedTresorTotal92
                                  : null}
                              </Text>
                            </View>
                          </View>
                        ) : null}

                        {isDependanceValid(simu84Index) ||
                        isDependanceValid(simu85Index) ||
                        isDependanceValid(simu92Index) ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={styles.detailsSubjectText}>
                                 Dont TPF (0,71498%) (base de calcul majorée des accessoires {isDependanceValid(simu84Index) ? getTauxAccessoiresForSimulateur(84) : isDependanceValid(simu85Index) ? getTauxAccessoiresForSimulateur(85) : isDependanceValid(simu92Index) ? getTauxAccessoiresForSimulateur(92) : getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%)
                              </Text>
                            </View>
                            {isDependanceValid(simu84Index) ||
                            isDependanceValid(simu85Index) ||
                            isDependanceValid(simu92Index) ? (
                              <View style={styles.detailsBaseField}>
                                <Text style={styles.detailsBaseText}>
                                  {isDependanceValid(simu84Index)
                                    ? formattedBaseTpf84
                                    : isDependanceValid(simu85Index)
                                    ? formattedBaseTpf85
                                    : isDependanceValid(simu92Index)
                                    ? formattedBaseTpf92
                                    : null}
                                </Text>
                              </View>
                            ) : null}
                            {isDependanceValid(simu84Index) ||
                            isDependanceValid(simu85Index) ||
                            isDependanceValid(simu92Index) ? (
                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu84Index)
                                  ? formattedTpfValue84
                                  : isDependanceValid(simu85Index)
                                  ? formattedTpfValue85
                                  : isDependanceValid(simu92Index)
                                  ? formattedTpfValue92
                                  : null}
                              </Text>
                            ) : null}
                          </View>
                        ) : null}
                        {isDependanceValid(simu84Index) ||
                        isDependanceValid(simu85Index) ||
                        isDependanceValid(simu92Index) ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={styles.detailsSubjectText}>
                                Dont CSI d’inscription (0,05%) (base de calcul majorée des accessoires {isDependanceValid(simu84Index) ? getTauxAccessoiresForSimulateur(84) : isDependanceValid(simu85Index) ? getTauxAccessoiresForSimulateur(85) : isDependanceValid(simu92Index) ? getTauxAccessoiresForSimulateur(92) : getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%)
                              </Text>
                            </View>
                            {isDependanceValid(simu84Index) ||
                            isDependanceValid(simu85Index) ||
                            isDependanceValid(simu92Index) ? (
                              <View style={styles.detailsBaseField}>
                                <Text style={styles.detailsBaseText}>
                                  {isDependanceValid(simu84Index)
                                    ? formattedBaseCsiInscription84
                                    : isDependanceValid(simu85Index)
                                    ? formattedBaseCsiInscription85
                                    : isDependanceValid(simu92Index)
                                    ? formattedBaseCsiInscription92
                                    : null}
                                </Text>
                              </View>
                            ) : null}
                            {isDependanceValid(simu84Index) ||
                            isDependanceValid(simu85Index) ||
                            isDependanceValid(simu92Index) ? (
                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu84Index)
                                  ? formattedCsiInscriptionValue84
                                  : isDependanceValid(simu85Index)
                                  ? formattedCsiInscriptionValue85
                                  : isDependanceValid(simu92Index)
                                  ? formattedCsiInscriptionValue92
                                  : null}
                              </Text>
                            ) : null}
                          </View>
                        ) : null}

                        {isDependanceValid(simu89Index) || isDependanceValid(simu96Index) || isDependanceValid(simu114Index) ? (
                          <View style={[styles.detailsRow, styles.detailsRowCompactBottom]}>
                            <View style={styles.totalEmolFormLeft}>
                              <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                                Droits dus au trésor : acte de cautionnement sans garantie
                              </Text>
                            </View>
                            <View style={styles.totalEmolFormMiddle}>
                              <Text style={styles.totalEmolFormValue}>
                                <></>
                              </Text>
                            </View>
                            <View style={styles.totalEmolFormRight}>
                              <Text style={styles.totalEmolFormValue}>
                                {isDependanceValid(simu89Index)
                                  ? formattedTresorTotal89
                                  : isDependanceValid(simu96Index)
                                  ? formattedTresorTotal96
                                  : isDependanceValid(simu114Index)
                                  ? formattedTresorTotal114
                                  : null}
                              </Text>
                            </View>
                          </View>
                        ) : null}
                      </View>

                      <View style={[styles.detailsContentTable, styles.detailsContentTableBorderBottom]}>
                        {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                                Droits dus au trésor : acte de cautionnement avec garantie
                              </Text>
                            </View>

                            <View style={styles.detailsBaseField}/>

                            <Text style={[styles.detailsMontantText, styles.detailsMontantTextBold]}>
                              {isDependanceValid(simu90Index)
                                ? formattedTresorTotal90
                                : isDependanceValid(simu97Index)
                                ? formattedTresorTotal97
                                : null}
                            </Text>
                          </View>
                        ) : null}

                        {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={styles.detailsSubjectText}>
                                Dont TPF (0,71498%) (base de calcul majorée des accessoires {isDependanceValid(simu90Index) ? getTauxAccessoiresForSimulateur(90) : isDependanceValid(simu97Index) ? getTauxAccessoiresForSimulateur(97) : getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%)
                              </Text>
                            </View>
                            {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                              <View style={styles.detailsBaseField}>
                                <Text style={styles.detailsBaseText}>
                                  {isDependanceValid(simu90Index)
                                    ? formattedBaseTresor90
                                    : isDependanceValid(simu97Index)
                                    ? formattedBaseTresor97
                                    : null}
                                </Text>
                              </View>
                            ) : null}
                            {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu90Index)
                                  ? formattedTpfValue90
                                  : isDependanceValid(simu97Index)
                                  ? formattedTpfValue97
                                  : null}
                              </Text>
                            ) : null}
                          </View>
                        ) : null}

                        {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={styles.detailsSubjectText}>
                                Dont CSI d'inscription (0,05%) (base de calcul majorée des accessoires {isDependanceValid(simu90Index) ? getTauxAccessoiresForSimulateur(90) : isDependanceValid(simu97Index) ? getTauxAccessoiresForSimulateur(97) : getTauxAccessoiresForSimulateur(requestSimu.simulateurid)}%)
                              </Text>
                            </View>
                            {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                              <View style={styles.detailsBaseField}>
                                <Text style={styles.detailsBaseText}>
                                  {isDependanceValid(simu90Index)
                                    ? formattedBaseTresor90
                                    : isDependanceValid(simu97Index)
                                    ? formattedBaseTresor97
                                    : null}
                                </Text>
                              </View>
                            ) : null}
                            {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                              <Text style={styles.detailsMontantText}>
                                {isDependanceValid(simu90Index)
                                  ? formattedCsiInscriptionValue90
                                  : isDependanceValid(simu97Index)
                                  ? formattedCsiInscriptionValue97
                                  : null}
                              </Text>
                            ) : null}
                          </View>
                        ) : null}
                      </View>
                    </>
                  ) : null}
                  {result.map((object) => {
                    if (
                      ((object.key === "droit_etat_acte_separe" && object.value !== "0 €") ||
                        (object.key === "droit_etat" && object.value !== "0 €") ||
                        (object.key === "droit_etat_simplifie" && object.value !== "0 €")) &&
                      !simuDependances.includes(requestSimu?.simulateurid)
                    ) {
                      return (
                        <View style={[styles.detailsContentTable, styles.detailsContentTableBorderBottom]}>
                          <View style={styles.detailsRow}>
                            <View style={styles.detailsSubjectField}>
                              <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                                Droits états
                              </Text>
                            </View>
                            <View style={styles.detailsBaseField}/>
                            <View style={styles.detailsEmptyCell} />
                          </View>

                          {object.key === "droit_etat_acte_separe" || object.key === "droit_etat" ? (
                            <>
                              <View style={styles.detailsRow}>
                                <View style={styles.detailsSubjectField}>
                                  <Text style={styles.detailsSubjectText}>
                                    {simuPret.includes(requestSimu.simulateurid)
                                      ? "Droit état prêt - acte séparé"
                                      : "Droit état"}
                                  </Text>
                                </View>
                                <View style={styles.detailsBaseField}/>
                                <Text style={styles.detailsMontantText}>
                                  {(() => {
                                    for (let i = 0; i < result.length; i++) {
                                      if (result[i].key === "droit_etat" || result[i].key === "droit_etat_acte_separe") {
                                        const formattedValue = parseInt(result[i].value)
                                          .toLocaleString("en-EN")
                                          .replace(/,/g, " ");
                                        return (formattedValue + " €").toString();
                                      }
                                    }
                                    return "";
                                  })()}
                                </Text>
                              </View>

                              {simuPret.includes(requestSimu.simulateurid) &&
                              (isDependanceValid(simu89Index) || isDependanceValid(simu96Index) || isDependanceValid(simu114Index)) ? (
                                <View style={styles.detailsRow}>
                                  <View style={styles.detailsSubjectField}>
                                    <Text style={styles.detailsSubjectText}>
                                      Droit état cautionnement sans garantie - acte séparé
                                    </Text>
                                  </View>
                                  <View style={styles.detailsBaseField}/>
                                  <Text style={styles.detailsMontantText}>
                                    {isDependanceValid(simu89Index)
                                      ? formattedDroitEtat89
                                      : isDependanceValid(simu96Index)
                                      ? formattedDroitEtat96
                                      : isDependanceValid(simu114Index)
                                      ? formattedDroitEtat114
                                      : null}
                                  </Text>
                                </View>
                              ) : null}

                              {simuPret.includes(requestSimu.simulateurid) &&
                              (isDependanceValid(simu90Index) || isDependanceValid(simu97Index)) ? (
                                <View style={styles.detailsRow}>
                                  <View style={styles.detailsSubjectField}>
                                    <Text style={styles.detailsSubjectText}>
                                      Droit état cautionnement avec garantie - acte séparé
                                    </Text>
                                  </View>
                                  <View style={styles.detailsBaseField}/>
                                  <Text style={styles.detailsMontantText}>
                                    {isDependanceValid(simu90Index)
                                      ? formattedDroitEtat90
                                      : isDependanceValid(simu97Index)
                                      ? formattedDroitEtat97
                                      : null}
                                  </Text>
                                </View>
                              ) : null}
                            </>
                          ) : null}

                          {object.key === "droit_etat_simplifie" ? (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Droit état simplfié
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>
                              <Text style={styles.detailsMontantText}>
                                {(() => {
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "droit_etat_simplifie") {
                                      const formattedValue = parseInt(result[i].value)
                                        .toLocaleString("en-EN")
                                        .replace(/,/g, " ");
                                      return (formattedValue + " €").toString();
                                    }
                                  }
                                  return "";
                                })()}
                              </Text>
                            </View>
                          ) : null}
                        </View>
                      );
                    } else {
                      return null;
                    }
                  })}

                  {/* {console.log("Contenu de simulateurObject:", simulateurObject)} */}

                  {(hasDroitEtat || hasDroitEtatPromesse || hasDroitEtatActeSepareDependances) &&
                  simuDependances.includes(requestSimu?.simulateurid) ? (
                    <View style={[styles.detailsContentTable, styles.detailsContentTableBorderBottom]}>
                      <View style={styles.detailsRow}>
                        <View style={styles.detailsSubjectField}>
                          <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextMedium]}>
                            Droits états
                          </Text>
                        </View>
                        <View style={styles.detailsBaseField}/>
                        <View style={styles.Rightlaw}/>
                      </View>

                      {isDependanceValid(simu84Index) ||
                      isDependanceValid(simu85Index) ||
                      isDependanceValid(simu92Index) ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Droit état prêt - acte séparé
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}/>
                          <Text style={styles.detailsMontantText}>
                            {isDependanceValid(simu84Index)
                              ? formattedDroitEtat84
                              : isDependanceValid(simu85Index)
                              ? formattedDroitEtat85
                              : isDependanceValid(simu92Index)
                              ? formattedDroitEtat92
                              : null}
                          </Text>
                        </View>
                      ) : null}

                      {isDependanceValid(simu89Index) || isDependanceValid(simu96Index) || isDependanceValid(simu114Index) ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Droit état cautionnement sans garantie - acte séparé
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}/>
                          <Text style={styles.detailsMontantText}>
                            {isDependanceValid(simu89Index)
                              ? formattedDroitEtat89
                              : isDependanceValid(simu96Index)
                              ? formattedDroitEtat96
                              : isDependanceValid(simu114Index)
                              ? formattedDroitEtat114
                              : null}
                          </Text>
                        </View>
                      ) : null}

                      {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
                        <View style={styles.detailsRow}>
                          <View style={styles.detailsSubjectField}>
                            <Text style={styles.detailsSubjectText}>
                              Droit état cautionnement avec garantie - acte séparé
                            </Text>
                          </View>
                          <View style={styles.detailsBaseField}/>
                          <Text style={styles.detailsMontantText}>
                            {isDependanceValid(simu90Index)
                              ? formattedDroitEtat90
                              : isDependanceValid(simu97Index)
                              ? formattedDroitEtat97
                              : null}
                          </Text>
                        </View>
                      ) : null}

                      {result.map((object) => {
                        if (object.key === "droit_etat") {
                          return (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Droit état
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>
                              <Text style={styles.detailsMontantText}>
                                {(() => {
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "droit_etat") {
                                      const formattedValue = parseInt(result[i].value)
                                        .toLocaleString("en-EN")
                                        .replace(/,/g, " ");
                                      return (formattedValue + " €").toString();
                                    }
                                  }
                                  return "";
                                })()}
                              </Text>
                            </View>
                          );
                        } else {
                          return null;
                        }
                      })}

                      {result.map((object) => {
                        if (object.key === "droit_etat_simplifie") {
                          return (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Droit état simplfié
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>
                              <Text style={styles.detailsMontantText}>
                                {(() => {
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "droit_etat_simplifie") {
                                      const formattedValue = parseInt(result[i].value)
                                        .toLocaleString("en-EN")
                                        .replace(/,/g, " ");
                                      return (formattedValue + " €").toString();
                                    }
                                  }
                                  return "";
                                })()}
                              </Text>
                            </View>
                          );
                        } else {
                          return null;
                        }
                      })}

                      {result.map((object) => {
                        if (object.key === "droit_etat_promesse" && object.value !== "0 €") {
                          return (
                            <View style={styles.detailsRow}>
                              <View style={styles.detailsSubjectField}>
                                <Text style={styles.detailsSubjectText}>
                                  Droit état promesse de vente
                                </Text>
                              </View>
                              <View style={styles.detailsBaseField}/>
                              <Text style={styles.detailsMontantText}>
                                {(() => {
                                  for (let i = 0; i < result.length; i++) {
                                    if (result[i].key === "droit_etat_promesse") {
                                      const formattedValue = parseInt(result[i].value)
                                        .toLocaleString("en-EN")
                                        .replace(/,/g, " ");
                                      return (formattedValue + " €").toString();
                                    }
                                  }
                                  return "";
                                })()}
                              </Text>
                            </View>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </View>
                  ) : null}
                </>
              );
            } else {
              return null;
            }
          })}

          <View style={styles.detailsContentTable}>
            <View style={[styles.detailsRow, styles.detailsRowCompact]}>
              <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                <Text style={[styles.detailsSubjectText, styles.detailsSubjectTextBold]}>
                  TOTAL DES DROITS DUS AU TRÉSOR PUBLIC (arrondi)
                </Text>
              </View>
              <View
                style={styles.totalEmolFormRight}/>
              <View
                style={styles.promesseRight}>
                <Text
                  style={styles.totalEmolFormValue}>
                  {(() => {
                    for (let i = 0; i < result.length; i++) {
                      if (result[i].key === "Tresor_total") {
                        const numericValue = parseFloat(result[i].value);
                        const roundedValue = Math.ceil(numericValue);
                        const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                        return (formattedValue + " €").toString();
                      }
                    }
                    return "";
                  })()}
                </Text>
              </View>
            </View>
          </View>
        </View>
        {/* END BLOC 3 */}
        <View
          style={[styles.totalRow, styles.totaltaxation]}>
          <Text style={styles.totalText}>
            TOTAL FISCALITÉ (arrondi)
          </Text>

          <Text style={styles.totalText}>
            {(() => {
              const tvaValue = (() => {
                for (let i = 0; i < result.length; i++) {
                  if (result[i].key === "TVA_total") {
                    return parseFloat(result[i].value) || 0;
                  }
                }
                return 0;
              })();
              const tresorValue = (() => {
                for (let i = 0; i < result.length; i++) {
                  if (result[i].key === "Tresor_total") {
                    return parseFloat(result[i].value) || 0;
                  }
                }
                return 0;
              })();
              const roundedTotal = Math.ceil(tvaValue + tresorValue) - (requestSimu.pdfInputs['montant_convention_honoraires'] * tauxTva);
              const formattedValue = roundedTotal.toLocaleString("en-EN").replace(/,/g, " ") + " €";
              return formattedValue;
            })()}
          </Text>
        </View>

        {requestSimu.simulateurid === 115 && requestSimu.inputs.type_demembrement === 1 ? (
          <>
            <View 
              style={[styles.totalRow, styles.totaltaxationCharge]} >
              <Text style={[styles.totalText, styles.totaltaxationChargeText]}>
                Total fiscalité à la charge de l'usufruitier HT (arrondi)
              </Text>

              <Text style={[styles.totalText, styles.totalTextSmallFlex04]}>
                {(() => {
                  const tvaUs = parseFloat(result.find(item => item.key === "tva_us")?.value || 0)
                  const dmtoUs = parseFloat(result.find(item => item.key === "dmto_usufruitier")?.value || 0)
                  const proportionFiscaleUs = requestSimu.inputs.us_fiscale / requestSimu.inputs.montant_vente
                  const csiUs = parseFloat(result.find(item => item.key === "csi_publication")?.value || 0) * proportionFiscaleUs
                  const taxeIDFUs = parseFloat(result.find(item => item.key === "taxe_ile_de_france")?.value || 0) * proportionFiscaleUs
                  const droitsPromesseUs = parseFloat(result.find(item => item.key === "droit_etat_promesse")?.value || 0) * proportionFiscaleUs
                  const totalFiscaliteUs = Math.ceil(tvaUs + dmtoUs + csiUs + taxeIDFUs + droitsPromesseUs).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                  return totalFiscaliteUs;
                })()}
              </Text>
            </View>

            <View 
              style={[styles.totalRow, styles.totaltaxationCharge2]}>
              <Text style={[styles.totalText, styles.totaltaxationChargeText]}>
                Total fiscalité à la charge du nu-propriétaire HT (arrondi)
              </Text>

              <Text style={[styles.totalText, styles.totalTextSmallFlex04]}>
                {(() => {
                  const tvaNP = parseFloat(result.find(item => item.key === "tva_np")?.value || 0)
                  const dmtoNP = parseFloat(result.find(item => item.key === "dmto_nu_proprietaire")?.value || 0)
                  const proportionFiscaleNP = requestSimu.inputs.np_fiscale / requestSimu.inputs.montant_vente
                  const csiNP = parseFloat(result.find(item => item.key === "csi_publication")?.value || 0) * proportionFiscaleNP
                  const taxeIDFNP = parseFloat(result.find(item => item.key === "taxe_ile_de_france")?.value || 0) * proportionFiscaleNP
                  const droitsPromesseNP = parseFloat(result.find(item => item.key === "droit_etat_promesse")?.value || 0) * proportionFiscaleNP
                  const totalFiscaliteNP = Math.ceil(tvaNP + dmtoNP + csiNP + taxeIDFNP + droitsPromesseNP).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                  return totalFiscaliteNP;
                })()}
              </Text>
            </View>
          
          </>
        ) : null}

        <View
          style={[styles.themeTable, styles.themedebours]}>
          <View style={[styles.themeHeader, styles.themeHeaderDebours]}>
            <Text style={styles.themeHeaderText}>
              DÉTAIL DÉBOURS
            </Text>
          </View>

          <View style={styles.container49}>
            <Text style={styles.persoEmolHeaderText} >
              DÉBOURS
            </Text>
          </View>

          <View style={styles.detailsContentTable}>
            <View style={[styles.detailsRow, styles.detailsRowCompact]}>
              {simulateurObject.data.inputs.montant_vente !== null &&
              simulateurObject.data.inputs.montant_vente !== undefined &&
              requestSimu.hasOwnProperty("dependances") ? (
                <>
                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                    <Text style={styles.detailsSubjectText}>
                      Débours acte de vente
                    </Text>
                  </View>
                  <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "base_debours") {
                            const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </>
              ) : (simulateurObject?.data?.inputs?.debours_additionnels === 1 || simulateurObject?.data?.inputs?.debours_additionnels === "1" || simulateurObject?.data?.inputs?.debours_additionnels === 2 || simulateurObject?.data?.inputs?.debours_additionnels === "2" || requestSimu.simulateurid === 22 || requestSimu.simulateurid === 23 || requestSimu.simulateurid === 24 || requestSimu.simulateurid === 25) ? (
                <>
                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                    <Text style={styles.detailsSubjectText}>
                      Débours
                    </Text>
                  </View>
                  <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "base_debours") {
                            const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </>
              ) : (
                <>
                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                    <Text style={styles.detailsSubjectText}>
                      Débours
                    </Text>
                  </View>
                  <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "Debours_total") {
                            const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </>
              )}
            </View>

            {isDependanceValid(simu84Index) || isDependanceValid(simu85Index) || isDependanceValid(simu92Index) ? (
              <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                  <Text style={styles.detailsSubjectText}>
                    Débours acte de prêt
                  </Text>
                </View>
                <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                    {isDependanceValid(simu84Index)
                      ? formattedDeboursValue84
                      : isDependanceValid(simu85Index)
                      ? formattedDeboursValue85
                      : isDependanceValid(simu92Index)
                      ? formattedDeboursValue92
                      : null}
                  </Text>
                </View>
              </View>
            ) : null}

            {isDependanceValid(simu89Index) || isDependanceValid(simu96Index) || isDependanceValid(simu114Index) ? (
              <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                  <Text style={styles.detailsSubjectText}>
                    Débours acte de cautionnement sans garantie
                  </Text>
                </View>
                <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                    {isDependanceValid(simu89Index)
                      ? formattedDeboursValue89
                      : isDependanceValid(simu96Index)
                      ? formattedDeboursValue96
                      : isDependanceValid(simu114Index)
                      ? formattedDeboursValue114
                      : null}
                  </Text>
                </View>
              </View>
            ) : null}

            {isDependanceValid(simu90Index) || isDependanceValid(simu97Index) ? (
              <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                  <Text style={styles.detailsSubjectText}>
                    Débours acte de cautionnement avec garantie
                  </Text>
                </View>
                <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                    {isDependanceValid(simu90Index)
                      ? formattedDeboursValue90
                      : isDependanceValid(simu97Index)
                      ? formattedDeboursValue97
                      : null}
                  </Text>
                </View>
              </View>
            ) : null}
          </View>

          {simulateurObject?.data?.inputs?.debours_additionnels === 1 || simulateurObject?.data?.inputs?.debours_additionnels === "1" || simulateurObject?.data?.inputs?.debours_additionnels === 2 || simulateurObject?.data?.inputs?.debours_additionnels === "2" ? (
            <View>
              <View style={styles.deboursSup}>
                <Text style={styles.persoEmolHeaderText}>
                  DÉBOURS SUPPLÉMENTAIRES À PRÉVOIR ET/OU DEMANDES D’URBANISME PARTICULIÈRES
                </Text>
              </View>

              <View style={styles.detailsContentTable}>
                <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                    <Text style={styles.detailsSubjectText}>
                      Débours supplémentaires à prévoir et/ou demandes d’urbanisme particulières
                    </Text>
                  </View>
                  <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                      {(() => {
                        for (let i = 0; i < result.length; i++) {
                          if (result[i].key === "debours_ou_urbanisme") {
                            const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");
                            return (formattedValue + " €").toString();
                          }
                        }
                        return "";
                      })()}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
          ) : null}
        </View>

        <View
          style={[styles.totalRow, styles.totaldebours]}>
          <Text style={styles.totalText}>
            TOTAL DÉBOURS
          </Text>

          <Text style={styles.totalText}>
            {(() => {
              for (let i = 0; i < result.length; i++) {
                if (result[i].key === "Debours_total") {
                  const formattedValue = parseInt(result[i].value).toLocaleString("en-EN").replace(/,/g, " ");
                  return (formattedValue + " €").toString();
                }
              }
              return "";
            })()}
          </Text>
        </View>

        {requestSimu.simulateurid === 115 && requestSimu.inputs.type_demembrement === 1 ? (
          <>
            <View style={[styles.totalRow, styles.totaltaxationCharge3]}>
              <Text style={[styles.totalText, styles.totaltaxationChargeText]}>
                Total débours à la charge de l'usufruitier HT (arrondi)
              </Text>

              <Text style={[styles.totalText, styles.totalTextSmallFlex04]}>
                {(() => {
                  const proportionUs = parseFloat(result.find(item => item.key === "proportion_us")?.value || 0) / 100
                  const deboursUs = Math.ceil(parseFloat(result.find(item => item.key === "Debours_total")?.value || 0) * proportionUs)
                    .toLocaleString("en-EN").replace(/,/g, " ") + " €";
                  return deboursUs;
                })()}
              </Text>
            </View>

            <View style={[styles.totalRow, styles.totaltaxationCharge4]}>
              <Text style={[styles.totalText, styles.totaltaxationChargeText]}>
                Total débours à la charge du nu-propriétaire HT (arrondi)
              </Text>

              <Text style={[styles.totalText, styles.totalTextSmallFlex04]}>
                {(() => {
                  const proportionNP = parseFloat(result.find(item => item.key === "proportion_np")?.value || 0) / 100
                  const deboursNP = Math.ceil(parseFloat(result.find(item => item.key === "Debours_total")?.value || 0) * proportionNP)
                    .toLocaleString("en-EN").replace(/,/g, " ") + " €";
                  return deboursNP;
                })()}
              </Text>
            </View>
          
          </>
        ) : null}

        {/*Total Honoraires*/}
          {simulateurObject?.data?.inputs?.convention_honoraires === 1 || simulateurObject?.data?.inputs?.convention_honoraires === "1" ? (
            <>
            <View style={[styles.themeTable, styles.totalHonoraires]}>
            <View style={[styles.themeHeader, styles.themeHeaderHonoraires]} >
              <Text style={styles.themeHeaderText}>
                DÉTAIL HONORAIRES
              </Text>
            </View>
            <View style={styles.detailsContentTable}>
              <View style={[styles.detailsRow, styles.tvaRowContainer ]}>
                <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                  <Text style={styles.detailsSubjectText}>
                    Honoraires HT
                  </Text>
                </View>
                <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                    {parseInt(requestSimu.pdfInputs["montant_convention_honoraires"]).toLocaleString("en-EN").replace(/,/g, " ") +
                        " €"}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.detailsContentTable}>
              <View style={[styles.detailsRow, styles.tvaRowContainer ]}>
                <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                  <Text style={styles.detailsSubjectText}>
                    Tva sur honoraires (arrondi)
                  </Text>
                </View>
                <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                    {(
                      (parseFloat(requestSimu.pdfInputs["montant_convention_honoraires"]) || 0) * tauxTva).toLocaleString("en-EN").replace(/,/g, " ")} €
                  </Text>
                </View>
              </View>
            </View>
          </View>
          <View
            style={[styles.totalRow, styles.totalhoraireTTC]}>
            <Text style={styles.totalText}>
              TOTAL HONORAIRES TTC
            </Text>

            <Text style={styles.totalText}>
              {montantTTC_honoraires.toLocaleString("en-EN").replace(/,/g, " ")} €
            </Text>
          </View>

          {requestSimu.simulateurid === 115 && requestSimu.inputs.type_demembrement === 1 ? (
            <>
              <View 
                style={[styles.totalRow, styles.totalhonoraireUsufruct]}>
                <Text style={[styles.totalText, styles.totaltaxationChargeText]}>
                  Total honoraires à la charge de l'usufruitier HT (arrondi)
                </Text>

                <Text style={[styles.totalText, styles.totalTextSmallFlex04]}>
                  {(() => {
                    const proportionUs = parseFloat(result.find(item => item.key === "proportion_us")?.value || 0) / 100
                    const honorairesUs = Math.ceil(parseFloat(montantTTC_honoraires || 0) * proportionUs).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                    return honorairesUs;
                  })()}
                </Text>
              </View>

              <View 
                style={[styles.totalRow, styles.totalhonoraireUsufruct2]}>
                <Text style={[styles.totalText, styles.totaltaxationChargeText]}>
                  Total honoraires à la charge du nu-propriétaire HT (arrondi)
                </Text>

                <Text style={[styles.totalText, styles.totalTextSmallFlex04]}>
                  {(() => {
                    const proportionNP = parseFloat(result.find(item => item.key === "proportion_np")?.value || 0) / 100
                    const honorairesNP = Math.ceil(parseFloat(montantTTC_honoraires || 0) * proportionNP).toLocaleString("en-EN").replace(/,/g, " ") + " €";
                    return honorairesNP;
                  })()}
                </Text>
              </View>
            
            </>
          ) : null}
          </>
          ) : null}


{/*Montant total provision sur frais*/}

        <View
          style={[styles.totalRow, styles.Totalprevision]}>
          <Text style={styles.totalText}>
            MONTANT TOTAL DE LA PROVISION SUR FRAIS (arrondi)
          </Text>

          <Text style={styles.totalText}>
            {(() => {
              for (let i = 0; i < result.length; i++) {
                if (result[i].key === "Provision_total") {
                  const numericValue = (parseFloat(result[i].value) || 0);
                  const roundedValue = Math.ceil(numericValue);
                  const formattedValue = roundedValue.toLocaleString("en-EN").replace(/,/g, " ");
                  return (formattedValue + " €").toString();
                }
              }
              return "";
            })()}
          </Text>
        </View>

        <View style={styles.bodyFooterCtn} fixed>
          <Text style={styles.bodyFooterMedium}>
            IMPORTANT : Les informations et les résultats présentés ci-dessus sont donnés à titre indicatif et ne
            peuvent en aucun cas constituer un document à caractère contractuel. Les frais indiqués doivent être
            adressés par virement au minimum 48h-72h à l'avance.
          </Text>
          <Text style={styles.bodyFooterLight}>Sources : Éditions Langloÿs - Le Barème Rapide® {year}</Text>
        </View>
      </Page>
      {/*  END P3  */}
      
      {/* P4 */}
      
      {simulateurObject?.data?.inputs?.convention_honoraires === 1 || simulateurObject?.data?.inputs?.convention_honoraires === "1" ? (
        <>
        {Array.from({ length: nombreExemplaires }).map((_, index) => (
          <Page key={`convention-${index}`} size="A4" style={styles.page}>
            <View style={styles.headerRight}>
              <StudyLogoPDF user={currUser} />
              <Text style={styles.headerName}>{currUser.societe}</Text>
              <Text style={styles.headerAdress}>{currUser.societe_address}</Text>

              <Text style={styles.headerAdress}>{currUser.societe_zip + " " + currUser.societe_town}</Text>

              <Text style={styles.headerDate}>Dossier suivi par : {currUser.firstname + " " + currUser.lastname}</Text>

              <View style={styles.headerDate}>
                <Text>Le : {currentDate}</Text>
              </View>
            </View>
            
            <View style={styles.feeAgreement}>
              <View style={[styles.themeHeader, styles.themeHeaderHonoraires]}>
                <Text style={styles.themeHeaderText}>
                  CONVENTION D'HONORAIRES (Article L.444-1 du Code de Commerce)
                </Text>
              </View>
            </View>
            <Text style={styles.ObjectConvention}>Objet de la Convention : { requestSimu.pdfInputs["object_convention_honoraires"] }</Text>
            <View style={styles.feeAgreement}>
              <View style={[styles.themeHeader, styles.themeHeaderGrey]}>
                <Text style={styles.themeHeaderText}>
                  DÉTAIL HONORAIRES
                </Text>
              </View>
              <View style={styles.detailsContentTable}>
                <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                    <Text style={styles.detailsSubjectText}>
                      Honoraires HT
                    </Text>
                  </View>
                  <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                      {parseInt(requestSimu.pdfInputs["montant_convention_honoraires"]).toLocaleString("en-EN").replace(/,/g, " ") +
                          " €"}
                    </Text>
                  </View>
                </View>
              </View>
              <View style={styles.detailsContentTable}>
                <View style={[styles.detailsRow, styles.detailsRowCompact]}>
                  <View style={[styles.detailsSubjectField, styles.detailsSubjectFieldH25]}>
                    <Text style={styles.detailsSubjectText}>
                      Tva sur honoraires (arrondi)
                    </Text>
                  </View>
                  <View style={styles.promesseRight1}>
                    <Text style={styles.promesseRight1Text}>
                      {(
                      (parseFloat(requestSimu.pdfInputs["montant_convention_honoraires"]) || 0) * tauxTva).toLocaleString("en-EN").replace(/,/g, " ")} €
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <View style={styles.tvaHonoraires}>
              <Text style={styles.totalText}>
                TOTAL HONORAIRES
              </Text>

              <Text style={styles.totalText}>
                {montantTTC_honoraires.toLocaleString("en-EN").replace(/,/g, " ")} €
              </Text>
            </View>
            {/* Conteneur principal pour les deux cadres */}
            <View
              style={styles.MaintvaHonoraires}>
              {/* Carré de Gauche (pour le Client) */}
              <View style={styles.MaintvaHonorairesleft}>
                {/* Partie haute du cadre */}
                <View>
                  <Text style={styles.signatureTitle}>
                    {requestSimu.pdfInputs["nom_signataire_convention_honoraires"] || "Le Client"}
                  </Text>
                  {requestSimu.pdfInputs["adresse_signataire_convention_honoraires"] ? (
                    <Text style={{ marginTop: 8 }}>
                      {requestSimu.pdfInputs["adresse_signataire_convention_honoraires"]}
                    </Text>
                  ) : null}
                </View>

                {/* Partie basse du cadre */}
                <Text style={styles.signatureLabel}>
                  Lu et approuvé, bon pour accord
                </Text>
              </View>

              {/* Carré de Droite (pour votre Société) */}
              <View style={styles.MaintvaHonorairesright}>
                {/* Partie haute du cadre */}
                <View>
                  <Text>Fait à {currUser.societe_town || "............................."}, le {currentDate}</Text>
                  <Text style={styles.signatureTitle}>
                    Par {currUser.societe}
                  </Text>
                </View>
                
                {/* Partie basse du cadre */}
                <Text style={styles.signatureLabel}>
                  (Cachet et signature)
                </Text>
              </View>
            </View>
            <View style={styles.bodyFooterCtn} fixed>
              <Text style={styles.bodyFooterLawBold}>
                Article L.444-1 du Code de commerce dipose :
              </Text>
              <Text style={styles.bodyFooterLaw}>
                Sont régis par le présent titre les tarifs réglementés applicables aux prestations des commissaires de justice, des greffiers de tribunal de commerce, des administrateurs judiciaires, des mandataires judiciaires et des notaires. Sont également régis par le présent titre les droits et émoluments de l'avocat en matière de saisie immobilière, de partage, de licitation et de sûretés judiciaires mentionnés à l' article 10 de la loi n° 71-1130 du 31 décembre 1971 portant réforme de certaines professions judiciaires et juridiques.
              </Text>
              <Text style={styles.bodyFooterLaw}>
                Sauf disposition contraire, lorsqu'un professionnel mentionné au premier alinéa du présent article est autorisé à exercer une activité dont la rémunération est soumise à un tarif propre à une autre catégorie d'auxiliaire de justice ou d'officier public ou ministériel, sa rémunération est arrêtée conformément aux règles dudit tarif. Les prestations accomplies par les personnes mentionnées au deuxième alinéa de l'article L. 811-2 et au premier alinéa du II de l'article L. 812-2 sont rémunérées conformément aux tarifs réglementés applicables aux administrateurs et mandataires judiciaires.
              </Text>
              <Text style={styles.bodyFooterLaw}>
                Sauf disposition contraire, les prestations que les professionnels mentionnés au premier alinéa du présent article accomplissent en concurrence avec celles, non soumises à un tarif, d'autres professionnels ne sont pas soumises à un tarif réglementé. Les honoraires rémunérant ces prestations tiennent compte, selon les usages, de la situation de fortune du client, de la difficulté de l'affaire, des frais exposés par les professionnels concernés, de leur notoriété et des diligences de ceux-ci. Les professionnels concernés concluent par écrit avec leur client une convention d'honoraires, qui précise, notamment, le montant ou le mode de détermination des honoraires couvrant les diligences prévisibles, ainsi que les divers frais et débours envisagés.
              </Text>
              <Text style={styles.bodyFooterLawBold}>
                Annexe 4-9 du Code de commerce (décret n° 2016-230 du 26 février 2016) dispose :
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                4° S'agissant des notaires :
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                a) Les consultations, sous réserve qu'elles soient détachables des prestations figurant sur la liste prévue au 1° de l'article R. 444-3 ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                b) Les négociations, définies comme les prestations par lesquelles le notaire, agissant en vertu d'un mandat écrit que lui a donné à cette fin l'une des parties, recherche un cocontractant, le découvre et le met en relation avec son mandant, soit directement, soit par l'intermédiaire du représentant de ce cocontractant, reçoit l'acte ou participe à sa réception ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                c) Les transactions définies comme les prestations par lesquelles le notaire chargé de recevoir un acte dont la réalisation est subordonnée à la solution d'un désaccord, rapproche ou participe au rapprochement des parties, obtient ou participe à l'obtention de leur accord et rédige la convention prévue par l'article 2044 du code civil ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                d) Les contrats d'association ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                e) Les baux régis par le chapitre V du titre IV du livre Ier du présent code ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                f) Les contrats de louage d'ouvrage et d'industrie, salaires ou travaux ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                g) Les contrats de sociétés ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                h) Les ventes de fonds de commerce, d'éléments de fonds de commerce, d'unités de production, de branches d'activité d'entreprise ;
              </Text>
              <Text style={styles.bodyFooterLawMargin}>
                j) Les ventes par adjudication volontaire de meubles et objets mobiliers, d'arbres en détail et de bateaux.
              </Text>
              <Text style={styles.bodyFooterLaw}>
                II. - Sauf stipulation contraire, l'honoraire de la négociation mentionnée au b du 4° du I est à la charge de celle des parties qui supporte les frais de l'acte.
                Les frais de publicité nécessaires à la recherche d'un co-contractant sont à la charge du notaire. Cependant, le mandant peut s'obliger à les lui rembourser sur justification dans la limite d'une somme précisée dans le mandat.
              </Text>
              <Text style={styles.bodyFooterLaw}>
                III. - Les honoraires de la négociation et de la transaction, respectivement mentionnées aux b et c du 4° du I, sont exclusifs l'un de l'autre.
                L'honoraire de transaction ne peut être perçu par le notaire qu'à la réception de l'acte et seulement si ce dernier mentionne les points sur lesquels portait le désaccord.
              </Text>
              <Text style={styles.bodyFooterLawBold}>
                Article R444-16 du Code de commerce dipose :
              </Text>
              <Text style={styles.bodyFooterLaw}>
              Hormis ceux dus au titre d'un mandat de justice, les honoraires perçus en application du troisième alinéa de l'article L. 444-1 sont fixés librement entre le professionnel et le client, dans les conditions et selon les modalités prévues par ce texte et sous le contrôle de l'instance professionnelle désignée pour chaque profession par arrêté du garde des sceaux, ministre de la justice. En cas de contestation, ces honoraires sont fixés par le juge chargé de la taxation.
              </Text>
              <Text style={styles.bodyFooterLight}>Sources : Légifrance /  {year} X Éditions Langloys - Le Barème Rapide® {year}</Text>
            </View>
          </Page>
        ))}
      </>
      ) : null}
      {/* END P4 */}
      {/* restitution des DMTG */}

      {requestSimu?.DMTG?.length > 0 ? (
        <GenerateDMTGPdfFile
          embedded
          requestSimuOverride={dmtgPdfRequest}
          simulateurObject={dmtgPdfResults}
        />
      ) : null}
      {/* END restitution des DMTG */}

      {/* restitution viager */}
      {requestSimu.simulateurid === 117 ?
        <Page style={styles.page}>
          <View style={styles.headerRight}>
            <StudyLogoPDF user={currUser} />
          <Text style={styles.headerName}>{currUser.societe}</Text>
          <Text style={styles.headerAdress}>{currUser.societe_address}</Text>

          <Text style={styles.headerAdress}>{currUser.societe_zip + " " + currUser.societe_town}</Text>

          <Text style={styles.headerDate}>Dossier suivi par : {currUser.firstname + " " + currUser.lastname}</Text>

          <View style={styles.headerDate}>
            <Text>Le : {currentDate}</Text>
          </View>
        </View>

          <View style={[styles.ttc, styles.ttcOverflowAuto]}>
            <View style={styles.column}>
              <Text style={styles.importantInfoTitle}>Détermination de certains éléments importants :</Text>

              <View style={styles.otherResultsBlock}>
                {simulateurObject.data.inputs.type_viager && (
                  <Text style={styles.otherResults}>
                    Type de viager : {simulateurObject.data.inputs.type_viager === 0 ? "Libre" : "Occupé"}
                  </Text>
                )}
                {simulateurObject.data.inputs.montant_vente && (
                  <Text style={styles.otherResults}>
                    Valeur vénale de l'immeuble : {parseInt(simulateurObject.data.inputs.montant_vente).toLocaleString("en-EN").replace(/,/g, " ")} €
                  </Text>
                )}
                {result.find(item => item.key === "charges_usufructuaires") && (
                  <Text style={styles.otherResults}>
                    Montant total des charges usufructuaires :{" "}
                    {parseInt(result.find(item => item.key === "charges_usufructuaires")?.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                  </Text>
                )}
                {result.find(item => item.key === "taux_rendement_usufruit") && (
                  <Text style={styles.otherResults}>
                    Taux de rendement net de charges usufructuaires : {result.find(item => item.key === "taux_rendement_usufruit")?.value}
                  </Text>
                )}
                {simulateurObject.data.inputs.esperance_vie_usufruitier && (
                  <Text style={styles.otherResults}>
                    Espérance de vie {simulateurObject.data.inputs.type_viager === 0 
                      ? "du crédirentier "
                      : simulateurObject.data.inputs.esperance_vie_us_successif > 0
                        ? "de l’usufruitier ou du titulaire du DUH actuel"
                        : "de l’usufruitier ou du titulaire du DUH"}
                    : {parseInt(simulateurObject.data.inputs.esperance_vie_usufruitier).toLocaleString("en-EN")} ans
                  </Text>
                )}
                {simulateurObject.data.inputs.esperance_vie_us_successif > 0 ? (
                  <Text style={styles.otherResults}>
                    Espérance de vie de l'usufruitier ou du titulaire du DUH successif :{" "}
                    {parseInt(simulateurObject.data.inputs.esperance_vie_us_successif).toLocaleString("en-EN")} ans
                  </Text>
                ) : null}
                {result?.map((object, index) => {
                  if (result[index].key === "valeur_usufruit") {
                      return (
                          <Text style={styles.otherResults}>
                              Valeur {simulateurObject.data.inputs.reserve ? "du droit d’usage " : "de l’usufruit "}
                              retenu : {parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "valeur_usufruit_actuel") {
                      return (
                          <Text style={styles.otherResults}>
                              Valeur {simulateurObject.data.inputs.reserve ? "du DUH " : "de l’usufruit "}
                              actuel retenu : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "valeur_usufruit_successif") {
                      return (
                          <Text style={styles.otherResults}>
                              Valeur {simulateurObject.data.inputs.reserve ? "du DUH " : "de l’usufruit "}
                              successif constitué : {" "}{parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  } else if (result[index].key === "valeur_nue_propriété") {
                      return (
                          <Text style={styles.otherResults}>
                              Prix d’acquisition de la nue-propriété {simulateurObject.data.inputs.reserve ? "grevée du DUH : " : ""}
                              {parseInt(result[index].value).toLocaleString("en-EN").replace(/,/g, " ")}{" "}€
                          </Text>
                      );
                  }
                  return <></>;
                })}
                {simulateurObject.data.inputs.montant_bouquet && (
                  <Text style={styles.otherResults}>
                    Montant du bouquet : {parseInt(simulateurObject.data.inputs.montant_bouquet).toLocaleString("en-EN").replace(/,/g, " ")} €
                  </Text>
                )}
                {result.find(item => item.key === "montant_annuel_rente") && (
                  <Text style={styles.otherResults}>
                    Montant annuel de la rente :{" "}
                    {parseInt(result.find(item => item.key === "montant_annuel_rente")?.value).toLocaleString("en-EN").replace(/,/g, " ")} €
                  </Text>
                )}
              </View>
            </View>
          </View>

          {/* MAP FOR INPUTS, rappel du 117*/}

          <View style={styles.rappel} wrap={false} minPresenceAhead={100}>
            <Text style={styles.bodyFooterMappedTitle}>Rappel de votre simulation :</Text>
            {requestSimu?.departementid !== 0 ? (
              <Text style={styles.bodyFooterMapped}>
                Département concerné :{" "}
                {requestSimu.departementid < 10 ? `0${requestSimu.departementid}` : requestSimu.departementid}
                {/*TODO Afficher le nom du département*/}
              </Text>
            ) : (
              <></>
            )}
            {Object.keys(requestSimu?.inputs).map((key) => {
              if (key === "valeur_locative_brute") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>
                    Revenus locatifs annuels bruts :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>;
                }
              } else if (key === "travaux_entretient_annuel") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>
                    Montant des travaux d’entretien annuels :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>;
                }
              } else if (key === "fraction_fond_travaux_charges") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>
                    Fraction du fonds de travaux afférente aux charges usufructuaires :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>;
                }
              } else if (key === "taxe_fonciere") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>
                    Montant de la taxe foncière :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>;
                }
              } else if (key === "taxe_logement_vacant") {
                if (requestSimu.inputs[key] > 0) {
                  return <Text style={styles.bodyFooterMapped}>
                    Montant de la taxe sur les logements vacants :{" "}
                    {parseInt(requestSimu.inputs[key]).toLocaleString("en-EN").replace(/,/g, " ") + " €"}
                  </Text>;
                }
              } else if (key === "usufruitier_successif") {
                if (requestSimu.inputs[key] === 1) {
                  return <Text style={styles.bodyFooterMapped}>Usufruit successif ou droit d’usage successif : Oui</Text>;
                }
              } else if (key === "taux_accessoires" && simuPret.includes(requestSimu.simulateurid)) {
                if (requestSimu.inputs[key] && parseFloat(requestSimu.inputs[key]) !== 20) {
                  return <Text style={styles.bodyFooterMapped}>Taux des accessoires : {parseFloat(requestSimu.inputs[key])}%</Text>;
                }
              } 

            })}
          </View>

          <View style={styles.bodyFooterCtn} fixed>
            <Text style={styles.bodyFooterMedium}>
              IMPORTANT : Les informations et les résultats présentés ci-dessus sont donnés à titre indicatif et ne
              peuvent en aucun cas constituer un document à caractère contractuel. Les frais indiqués doivent être
              adressés par virement au minimum 48h-72h à l'avance.
            </Text>
            <Text style={styles.bodyFooterLight}>Sources : Éditions Langloÿs - Le Barème Rapide® {year}</Text>
          </View>
        </Page>
        : null}
      {/* END restitution viager */}
      
    </Document>
  );
};
export default GeneratePdfFile;
